export const categories = {
    "1": {
        "name": "Yugtun Qalarcaraq, Qaneryaraq -- Yup'ik Language",
        "url": "Yugtun-Qalarcaraq-Qaneryaraq",
        "images": [
            "YugtunQalarcaraqQaneryaraq.jpg"
        ],
        "children": 2,
        "videoNumbers": [
            "cpb-aacip-127-009w0z0q.h264",
            "cpb-aacip-127-00ns1t6z.h264",
            "cpb-aacip-127-010p2r15.h264",
            "cpb-aacip-127-03cz8zdq.h264",
            "cpb-aacip-127-0644j324.h264",
            "cpb-aacip-127-06g1jzz6.h264",
            "cpb-aacip-127-06g1k008.h264",
            "cpb-aacip-127-09w0vx3c.h264",
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-10jsxpwg.h264",
            "cpb-aacip-127-10jsxpx6.h264",
            "cpb-aacip-127-14nk9d19.h264",
            "cpb-aacip-127-15p8d31m.h264",
            "cpb-aacip-127-16pzgr3f.h264",
            "cpb-aacip-127-18rbp380.h264",
            "cpb-aacip-127-20fttjr7.h264",
            "cpb-aacip-127-25k98x78.h264",
            "cpb-aacip-127-25x69tk3.h264",
            "cpb-aacip-127-26xwdh7k.h264",
            "cpb-aacip-127-27zkh5wz.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-33rv1b2m.h264",
            "cpb-aacip-127-53wstz0s.h264",
            "cpb-aacip-127-60qrfsqn.h264",
            "cpb-aacip-127-65v6x4wh.h264",
            "cpb-aacip-127-81jhb5w6.h264",
            "cpb-aacip-127-85n8pw5n.h264",
            "cpb-aacip-127-87pnw7r9.h264",
            "cpb-aacip-127-881jx4d6.h264",
            "cpb-aacip-127-945qg6jq.h264"
        ]
    },
    "1.1": {
        "name": "Qalarcarat -- Dialects",
        "url": "Qalarcarat",
        "images": [],
        "children": 3,
        "videoNumbers": [
            "cpb-aacip-127-009w0z0q.h264",
            "cpb-aacip-127-00ns1t6z.h264",
            "cpb-aacip-127-010p2r15.h264",
            "cpb-aacip-127-03cz8zdq.h264",
            "cpb-aacip-127-06g1jzz6.h264",
            "cpb-aacip-127-06g1k008.h264",
            "cpb-aacip-127-09w0vx3c.h264",
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-10jsxpwg.h264",
            "cpb-aacip-127-10jsxpx6.h264",
            "cpb-aacip-127-14nk9d19.h264",
            "cpb-aacip-127-15p8d31m.h264",
            "cpb-aacip-127-16pzgr3f.h264",
            "cpb-aacip-127-18rbp380.h264",
            "cpb-aacip-127-20fttjr7.h264",
            "cpb-aacip-127-25k98x78.h264",
            "cpb-aacip-127-25x69tk3.h264",
            "cpb-aacip-127-26xwdh7k.h264",
            "cpb-aacip-127-27zkh5wz.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-33rv1b2m.h264"
        ]
    },
    "1.1.1": {
        "name": "Yugtun, Yugcetun -- Yup'ik",
        "url": "Yugtun-Yugcetun",
        "images": [],
        "children": 7,
        "videoNumbers": [
            "cpb-aacip-127-009w0z0q.h264",
            "cpb-aacip-127-00ns1t6z.h264",
            "cpb-aacip-127-010p2r15.h264",
            "cpb-aacip-127-03cz8zdq.h264",
            "cpb-aacip-127-06g1jzz6.h264",
            "cpb-aacip-127-06g1k008.h264",
            "cpb-aacip-127-09w0vx3c.h264",
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-10jsxpwg.h264",
            "cpb-aacip-127-10jsxpx6.h264",
            "cpb-aacip-127-14nk9d19.h264",
            "cpb-aacip-127-15p8d31m.h264",
            "cpb-aacip-127-16pzgr3f.h264",
            "cpb-aacip-127-18rbp380.h264",
            "cpb-aacip-127-25k98x78.h264",
            "cpb-aacip-127-25x69tk3.h264",
            "cpb-aacip-127-26xwdh7k.h264",
            "cpb-aacip-127-27zkh5wz.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-33rv1b2m.h264"
        ]
    },
    "1.1.2": {
        "name": "Cugtun, Yugtun -- Cup'ik & Yup'ik of Hooper Bay & Chevak",
        "url": "Cugtun-Yugtun",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-06g1k008.h264",
            "cpb-aacip-127-10jsxpwg.h264",
            "cpb-aacip-127-20fttjr7.h264",
            "cpb-aacip-127-28ncjzpp.h264"
        ]
    },
    "1.2": {
        "name": "Uyaquq -- Lloyd Nick [Helper Neck]",
        "url": "Uyaquq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-81jhb5w6.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "1.2.1": {
        "name": "Uyaqum Igaryarai -- Uyaquq's Orthography",
        "url": "Uyaqum-Igaryarai",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-81jhb5w6.h264"
        ]
    },
    "2": {
        "name": "Nunat Mer'et-llu Atrit -- Place Names For Land And Bodies Of Water",
        "url": "Nunat-Meret-llu-Atrit",
        "images": [
            "NunatMeretlluAtrit.jpg"
        ],
        "children": 3,
        "videoNumbers": [
            "cpb-aacip-127-009w0z0q.h264",
            "cpb-aacip-127-00ns1t6z.h264",
            "cpb-aacip-127-010p2r15.h264",
            "cpb-aacip-127-032282mq.h264",
            "cpb-aacip-127-03cz8zdq.h264",
            "cpb-aacip-127-0644j324.h264",
            "cpb-aacip-127-0644j37r.h264",
            "cpb-aacip-127-06g1jzz6.h264",
            "cpb-aacip-127-06g1k008.h264",
            "cpb-aacip-127-085hqfqk.h264",
            "cpb-aacip-127-09w0vx3c.h264",
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-10jsxpwg.h264",
            "cpb-aacip-127-10jsxpx6.h264",
            "cpb-aacip-127-149p8hcz.h264",
            "cpb-aacip-127-14nk9d19.h264",
            "cpb-aacip-127-15p8d31m.h264",
            "cpb-aacip-127-16pzgr3f.h264",
            "cpb-aacip-127-18rbp380.h264",
            "cpb-aacip-127-20fttjr7.h264",
            "cpb-aacip-127-225b014v.h264",
            "cpb-aacip-127-23612qck.h264",
            "cpb-aacip-127-257d81kk.h264",
            "cpb-aacip-127-257d81m9.h264",
            "cpb-aacip-127-25k98x78.h264",
            "cpb-aacip-127-25x69tk3.h264",
            "cpb-aacip-127-26xwdh7k.h264",
            "cpb-aacip-127-27zkh5wz.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-2908kvc9.h264",
            "cpb-aacip-127-322bvwfr.h264",
            "cpb-aacip-127-33rv1b2m.h264",
            "cpb-aacip-127-34fn33pp.h264",
            "cpb-aacip-127-34sj40gx.h264",
            "cpb-aacip-127-35gb5sdj.h264",
            "cpb-aacip-127-35t76q2k.h264",
            "cpb-aacip-127-37hqc4tk.h264",
            "cpb-aacip-127-37vmd1rq.h264",
            "cpb-aacip-127-386hdxkk.h264",
            "cpb-aacip-127-386hdz1p.h264",
            "cpb-aacip-127-38w9gpk2.h264",
            "cpb-aacip-127-41mgqv1k.h264",
            "cpb-aacip-127-42n5thvk.h264",
            "cpb-aacip-127-440rz436.h264",
            "cpb-aacip-127-46254fdx.h264",
            "cpb-aacip-127-47rn8x0g.h264",
            "cpb-aacip-127-48ffbpfx.h264",
            "cpb-aacip-127-52j6qcr2.h264",
            "cpb-aacip-127-53wstz0s.h264",
            "cpb-aacip-127-54kkwqvx.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-558czhn9.h264",
            "cpb-aacip-127-57np5s39.h264",
            "cpb-aacip-127-59c5b6f6.h264",
            "cpb-aacip-127-59c5b6gx.h264",
            "cpb-aacip-127-59q2c3zn.h264",
            "cpb-aacip-127-60qrfsqn.h264",
            "cpb-aacip-127-623bkbxr.h264",
            "cpb-aacip-127-6341p189.h264",
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-65v6x4wh.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-67wm3hhj.h264",
            "cpb-aacip-127-68kd59ft.h264",
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-719kdf8m.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-74cnpfqb.h264",
            "cpb-aacip-127-74cnpfr2.h264",
            "cpb-aacip-127-74qjqbsc.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-7634tx89.h264",
            "cpb-aacip-127-76f1vspw.h264",
            "cpb-aacip-127-773txm5v.h264",
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-79h44thw.h264",
            "cpb-aacip-127-805x6mnx.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-81jhb5w6.h264",
            "cpb-aacip-127-84mkm6tr.h264",
            "cpb-aacip-127-85n8pw5n.h264",
            "cpb-aacip-127-86nzsk0r.h264",
            "cpb-aacip-127-87brvbt5.h264",
            "cpb-aacip-127-87pnw7r9.h264",
            "cpb-aacip-127-881jx4d6.h264",
            "cpb-aacip-127-89280sv6.h264",
            "cpb-aacip-127-89r22kjv.h264",
            "cpb-aacip-127-91sf7xm0.h264",
            "cpb-aacip-127-945qg6jq.h264",
            "cpb-aacip-127-956djvkd.h264",
            "cpb-aacip-127-96wwq9xv.h264",
            "cpb-aacip-127-988gtvzp.h264",
            "cpb-aacip-127-98mcvs0p.h264"
        ]
    },
    "2.1": {
        "name": "Mer'et Atrit -- Place Names For Bodies Of Water",
        "url": "Meret-Atrit",
        "images": [],
        "children": 3,
        "videoNumbers": [
            "cpb-aacip-127-59q2c3zn.h264",
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-87pnw7r9.h264"
        ]
    },
    "2.1.2": {
        "name": "Kusquqvak -- Kuskokwim River",
        "url": "Kusquqvak",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-87pnw7r9.h264"
        ]
    },
    "2.1.3": {
        "name": "Kiillaralliin -- Heart Lake",
        "url": "Kiillaralliin",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-59q2c3zn.h264"
        ]
    },
    "2.2": {
        "name": "Nunacuaraat Atrit -- Place Names For Villages",
        "url": "Nunacuaraat-Atrit",
        "images": [],
        "children": 70,
        "videoNumbers": [
            "cpb-aacip-127-009w0z0q.h264",
            "cpb-aacip-127-00ns1t6z.h264",
            "cpb-aacip-127-010p2r15.h264",
            "cpb-aacip-127-032282mq.h264",
            "cpb-aacip-127-03cz8zdq.h264",
            "cpb-aacip-127-0644j324.h264",
            "cpb-aacip-127-0644j37r.h264",
            "cpb-aacip-127-06g1jzz6.h264",
            "cpb-aacip-127-06g1k008.h264",
            "cpb-aacip-127-085hqfqk.h264",
            "cpb-aacip-127-09w0vx3c.h264",
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-10jsxpwg.h264",
            "cpb-aacip-127-10jsxpx6.h264",
            "cpb-aacip-127-149p8hcz.h264",
            "cpb-aacip-127-14nk9d19.h264",
            "cpb-aacip-127-15p8d31m.h264",
            "cpb-aacip-127-16pzgr3f.h264",
            "cpb-aacip-127-18rbp380.h264",
            "cpb-aacip-127-20fttjr7.h264",
            "cpb-aacip-127-225b014v.h264",
            "cpb-aacip-127-23612qck.h264",
            "cpb-aacip-127-257d81kk.h264",
            "cpb-aacip-127-257d81m9.h264",
            "cpb-aacip-127-25k98x78.h264",
            "cpb-aacip-127-25x69tk3.h264",
            "cpb-aacip-127-26xwdh7k.h264",
            "cpb-aacip-127-27zkh5wz.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-2908kvc9.h264",
            "cpb-aacip-127-322bvwfr.h264",
            "cpb-aacip-127-33rv1b2m.h264",
            "cpb-aacip-127-34fn33pp.h264",
            "cpb-aacip-127-34sj40gx.h264",
            "cpb-aacip-127-35gb5sdj.h264",
            "cpb-aacip-127-35t76q2k.h264",
            "cpb-aacip-127-37hqc4tk.h264",
            "cpb-aacip-127-37vmd1rq.h264",
            "cpb-aacip-127-386hdxkk.h264",
            "cpb-aacip-127-386hdz1p.h264",
            "cpb-aacip-127-38w9gpk2.h264",
            "cpb-aacip-127-41mgqv1k.h264",
            "cpb-aacip-127-42n5thvk.h264",
            "cpb-aacip-127-440rz436.h264",
            "cpb-aacip-127-46254fdx.h264",
            "cpb-aacip-127-47rn8x0g.h264",
            "cpb-aacip-127-48ffbpfx.h264",
            "cpb-aacip-127-52j6qcr2.h264",
            "cpb-aacip-127-53wstz0s.h264",
            "cpb-aacip-127-54kkwqvx.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-558czhn9.h264",
            "cpb-aacip-127-57np5s39.h264",
            "cpb-aacip-127-59c5b6f6.h264",
            "cpb-aacip-127-59c5b6gx.h264",
            "cpb-aacip-127-59q2c3zn.h264",
            "cpb-aacip-127-60qrfsqn.h264",
            "cpb-aacip-127-623bkbxr.h264",
            "cpb-aacip-127-6341p189.h264",
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-65v6x4wh.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-67wm3hhj.h264",
            "cpb-aacip-127-68kd59ft.h264",
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-719kdf8m.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-74cnpfqb.h264",
            "cpb-aacip-127-74cnpfr2.h264",
            "cpb-aacip-127-74qjqbsc.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-7634tx89.h264",
            "cpb-aacip-127-76f1vspw.h264",
            "cpb-aacip-127-773txm5v.h264",
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-79h44thw.h264",
            "cpb-aacip-127-805x6mnx.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-81jhb5w6.h264",
            "cpb-aacip-127-84mkm6tr.h264",
            "cpb-aacip-127-85n8pw5n.h264",
            "cpb-aacip-127-86nzsk0r.h264",
            "cpb-aacip-127-87brvbt5.h264",
            "cpb-aacip-127-87pnw7r9.h264",
            "cpb-aacip-127-881jx4d6.h264",
            "cpb-aacip-127-89280sv6.h264",
            "cpb-aacip-127-89r22kjv.h264",
            "cpb-aacip-127-91sf7xm0.h264",
            "cpb-aacip-127-945qg6jq.h264",
            "cpb-aacip-127-956djvkd.h264",
            "cpb-aacip-127-96wwq9xv.h264",
            "cpb-aacip-127-988gtvzp.h264",
            "cpb-aacip-127-98mcvs0p.h264"
        ]
    },
    "2.2.3": {
        "name": "Tapraq -- Stebbins",
        "url": "Tapraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-0644j324.h264"
        ]
    },
    "2.2.8": {
        "name": "Nunam Iqua -- Nunam Iqua [Sheldon's Point]",
        "url": "Nunam-Iqua",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-84mkm6tr.h264"
        ]
    },
    "2.2.9": {
        "name": "Asaacarsaq -- Mountain Village",
        "url": "Asaacarsaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-032282mq.h264",
            "cpb-aacip-127-09w0vx3c.h264",
            "cpb-aacip-127-25x69tk3.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-41mgqv1k.h264",
            "cpb-aacip-127-440rz436.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-84mkm6tr.h264",
            "cpb-aacip-127-988gtvzp.h264"
        ]
    },
    "2.2.10": {
        "name": "Negeqliq -- St. Mary's",
        "url": "Negeqliq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-032282mq.h264",
            "cpb-aacip-127-0644j324.h264",
            "cpb-aacip-127-26xwdh7k.h264",
            "cpb-aacip-127-41mgqv1k.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-84mkm6tr.h264"
        ]
    },
    "2.2.11": {
        "name": "Negeqliim Painga -- Pilot Station",
        "url": "Negeqliim-Painga",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-386hdz1p.h264",
            "cpb-aacip-127-440rz436.h264",
            "cpb-aacip-127-623bkbxr.h264"
        ]
    },
    "2.2.17": {
        "name": "Naparyaarmiut -- Hooper Bay",
        "url": "Naparyaarmiut",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-06g1k008.h264",
            "cpb-aacip-127-10jsxpwg.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-87brvbt5.h264",
            "cpb-aacip-127-96wwq9xv.h264"
        ]
    },
    "2.2.18": {
        "name": "Cev'aq -- Chevak",
        "url": "Cevaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-0644j324.h264",
            "cpb-aacip-127-20fttjr7.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-440rz436.h264",
            "cpb-aacip-127-57np5s39.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-76f1vspw.h264",
            "cpb-aacip-127-87brvbt5.h264"
        ]
    },
    "2.2.20": {
        "name": "Kayalivik -- Kayalivik",
        "url": "Kayalivik",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-25k98x78.h264",
            "cpb-aacip-127-74cnpfr2.h264"
        ]
    },
    "2.2.21": {
        "name": "Tununeq -- Tununak",
        "url": "Tununeq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-18rbp380.h264",
            "cpb-aacip-127-35gb5sdj.h264"
        ]
    },
    "2.2.22": {
        "name": "Nunakauyaq -- Toksook Bay",
        "url": "Nunakauyaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-54kkwrd6.h264"
        ]
    },
    "2.2.23": {
        "name": "Negteḿiut -- Nightmute",
        "url": "Negteḿiut",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-15p8d31m.h264",
            "cpb-aacip-127-23612qck.h264"
        ]
    },
    "2.2.26": {
        "name": "Qipneq -- Kipnuk",
        "url": "Qipneq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-06g1jzz6.h264"
        ]
    },
    "2.2.27": {
        "name": "Kuigilnguq -- Kwigillingok",
        "url": "Kuigilnguq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-257d81m9.h264",
            "cpb-aacip-127-37hqc4tk.h264",
            "cpb-aacip-127-440rz436.h264",
            "cpb-aacip-127-48ffbpfx.h264",
            "cpb-aacip-127-59q2c3zn.h264",
            "cpb-aacip-127-65v6x4wh.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-86nzsk0r.h264",
            "cpb-aacip-127-87pnw7r9.h264"
        ]
    },
    "2.2.28": {
        "name": "Kangirnaq -- Kongiganak",
        "url": "Kangirnaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-257d81m9.h264",
            "cpb-aacip-127-25x69tk3.h264",
            "cpb-aacip-127-34fn33pp.h264",
            "cpb-aacip-127-52j6qcr2.h264",
            "cpb-aacip-127-54kkwqvx.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-79h44thw.h264"
        ]
    },
    "2.2.29": {
        "name": "Ekvicuar -- Eek",
        "url": "Ekvicuar",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "2.2.30": {
        "name": "Tuntutuliaq -- Tuntutuliak",
        "url": "Tuntutuliaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-00ns1t6z.h264",
            "cpb-aacip-127-085hqfqk.h264",
            "cpb-aacip-127-149p8hcz.h264",
            "cpb-aacip-127-26xwdh7k.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-37vmd1rq.h264",
            "cpb-aacip-127-46254fdx.h264",
            "cpb-aacip-127-48ffbpfx.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-67wm3hhj.h264",
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-773txm5v.h264",
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-85n8pw5n.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "2.2.31": {
        "name": "Qinaq -- Qinaq",
        "url": "Qinaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-009w0z0q.h264",
            "cpb-aacip-127-15p8d31m.h264",
            "cpb-aacip-127-23612qck.h264",
            "cpb-aacip-127-37vmd1rq.h264",
            "cpb-aacip-127-47rn8x0g.h264",
            "cpb-aacip-127-48ffbpfx.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-74qjqbsc.h264",
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-881jx4d6.h264",
            "cpb-aacip-127-91sf7xm0.h264"
        ]
    },
    "2.2.32": {
        "name": "Naparyarraq -- Napakiak",
        "url": "Naparyarraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-06g1jzz6.h264",
            "cpb-aacip-127-06g1k008.h264",
            "cpb-aacip-127-16pzgr3f.h264",
            "cpb-aacip-127-26xwdh7k.h264",
            "cpb-aacip-127-38w9gpk2.h264",
            "cpb-aacip-127-47rn8x0g.h264",
            "cpb-aacip-127-6341p189.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-881jx4d6.h264",
            "cpb-aacip-127-91sf7xm0.h264"
        ]
    },
    "2.2.33": {
        "name": "Napaskiaq -- Napaskiak",
        "url": "Napaskiaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-35t76q2k.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "2.2.34": {
        "name": "Kuiggayagaq -- Oscarville",
        "url": "Kuiggayagaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-0644j37r.h264"
        ]
    },
    "2.2.35": {
        "name": "Nunapicuaq -- Nunapitchuk",
        "url": "Nunapicuaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-257d81kk.h264",
            "cpb-aacip-127-2908kvc9.h264",
            "cpb-aacip-127-34sj40gx.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-7634tx89.h264"
        ]
    },
    "2.2.36": {
        "name": "Kassigluq -- Kasigluk",
        "url": "Kassigluq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-15p8d31m.h264",
            "cpb-aacip-127-23612qck.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-322bvwfr.h264",
            "cpb-aacip-127-386hdxkk.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-66vx0v02.h264"
        ]
    },
    "2.2.37": {
        "name": "Atmaulluaq -- Atmautluak",
        "url": "Atmaulluaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-23612qck.h264",
            "cpb-aacip-127-386hdxkk.h264",
            "cpb-aacip-127-74cnpfqb.h264",
            "cpb-aacip-127-81jhb5w6.h264"
        ]
    },
    "2.2.38": {
        "name": "Mamterilleq -- Bethel",
        "url": "Mamterilleq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-010p2r15.h264",
            "cpb-aacip-127-06g1jzz6.h264",
            "cpb-aacip-127-06g1k008.h264",
            "cpb-aacip-127-09w0vx3c.h264",
            "cpb-aacip-127-10jsxpwg.h264",
            "cpb-aacip-127-10jsxpx6.h264",
            "cpb-aacip-127-18rbp380.h264",
            "cpb-aacip-127-225b014v.h264",
            "cpb-aacip-127-25k98x78.h264",
            "cpb-aacip-127-25x69tk3.h264",
            "cpb-aacip-127-26xwdh7k.h264",
            "cpb-aacip-127-27zkh5wz.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-322bvwfr.h264",
            "cpb-aacip-127-33rv1b2m.h264",
            "cpb-aacip-127-42n5thvk.h264",
            "cpb-aacip-127-440rz436.h264",
            "cpb-aacip-127-558czhn9.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-719kdf8m.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-74cnpfr2.h264",
            "cpb-aacip-127-805x6mnx.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-881jx4d6.h264",
            "cpb-aacip-127-89280sv6.h264",
            "cpb-aacip-127-956djvkd.h264",
            "cpb-aacip-127-98mcvs0p.h264"
        ]
    },
    "2.2.39": {
        "name": "Kuiggluk -- Kwethluk",
        "url": "Kuiggluk",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-03cz8zdq.h264",
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-14nk9d19.h264",
            "cpb-aacip-127-440rz436.h264",
            "cpb-aacip-127-48ffbpfx.h264",
            "cpb-aacip-127-53wstz0s.h264",
            "cpb-aacip-127-59c5b6f6.h264",
            "cpb-aacip-127-59q2c3zn.h264",
            "cpb-aacip-127-60qrfsqn.h264",
            "cpb-aacip-127-87pnw7r9.h264",
            "cpb-aacip-127-89r22kjv.h264",
            "cpb-aacip-127-945qg6jq.h264"
        ]
    },
    "2.2.40": {
        "name": "Akiacuar -- Akiachak",
        "url": "Akiacuar",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-48ffbpfx.h264",
            "cpb-aacip-127-59c5b6gx.h264"
        ]
    },
    "2.2.41": {
        "name": "Akiaq -- Akiak",
        "url": "Akiaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-68kd59ft.h264"
        ]
    },
    "2.2.42": {
        "name": "Tuulkessaaq -- Tuluksak",
        "url": "Tuulkessaaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-009w0z0q.h264",
            "cpb-aacip-127-06g1k008.h264",
            "cpb-aacip-127-15p8d31m.h264",
            "cpb-aacip-127-48ffbpfx.h264",
            "cpb-aacip-127-53wstz0s.h264",
            "cpb-aacip-127-59q2c3zn.h264",
            "cpb-aacip-127-74qjqbsc.h264"
        ]
    },
    "2.2.48": {
        "name": "Kuinerraq -- Quinhagak",
        "url": "Kuinerraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "2.2.64": {
        "name": "Nanvarnarrlak -- Nanvarnarrlak",
        "url": "Nanvarnarrlak",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-81jhb5w6.h264"
        ]
    },
    "2.2.65": {
        "name": "Urucaraq -- Urucaraq",
        "url": "Urucaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-10jsxpx6.h264",
            "cpb-aacip-127-25x69tk3.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-719kdfjd.h264"
        ]
    },
    "2.2.66": {
        "name": "Nunacuaq -- Nunacuaq",
        "url": "Nunacuaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-23612qck.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-322bvwfr.h264",
            "cpb-aacip-127-386hdxkk.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-956djvkd.h264"
        ]
    },
    "2.2.67": {
        "name": "Acacaryun -- Acacaryun",
        "url": "Acacaryun",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-09w0vx3c.h264",
            "cpb-aacip-127-25x69tk3.h264",
            "cpb-aacip-127-28ncjzpp.h264"
        ]
    },
    "2.2.68": {
        "name": "Anchorage -- Anchorage",
        "url": "Anchorage",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-26xwdh7k.h264",
            "cpb-aacip-127-85n8pw5n.h264"
        ]
    },
    "2.2.69": {
        "name": "Noatak -- Noatak",
        "url": "Noatak",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-386hdz1p.h264"
        ]
    },
    "2.2.70": {
        "name": "Kotzebue -- Kotzebue",
        "url": "Kotzebue",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-386hdz1p.h264"
        ]
    },
    "2.3": {
        "name": "Ingriq -- Mountain",
        "url": "Ingriq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-28ncjzpp.h264"
        ]
    },
    "3": {
        "name": "Ellavut -- Weather, Climate",
        "url": "Ellavut",
        "images": [
            "Ellavut.jpg"
        ],
        "children": 12,
        "videoNumbers": [
            "cpb-aacip-127-009w0z0q.h264",
            "cpb-aacip-127-00ns1t6z.h264",
            "cpb-aacip-127-032282mq.h264",
            "cpb-aacip-127-09w0vx3c.h264",
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-10jsxpwg.h264",
            "cpb-aacip-127-15p8d31m.h264",
            "cpb-aacip-127-16pzgr3f.h264",
            "cpb-aacip-127-18rbp380.h264",
            "cpb-aacip-127-23612qck.h264",
            "cpb-aacip-127-25x69tk3.h264",
            "cpb-aacip-127-26xwdh7k.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-33rv1b2m.h264",
            "cpb-aacip-127-440rz436.h264",
            "cpb-aacip-127-48ffbpfx.h264",
            "cpb-aacip-127-59c5b6gx.h264",
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-67wm3hhj.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-74qjqbsc.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-773txm5v.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "3.1": {
        "name": "Allrakum Ellalinqigutai -- Seasons",
        "url": "Allrakum-Ellalinqigutai",
        "images": [],
        "children": 4,
        "videoNumbers": [
            "cpb-aacip-127-00ns1t6z.h264",
            "cpb-aacip-127-032282mq.h264",
            "cpb-aacip-127-09w0vx3c.h264",
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-33rv1b2m.h264",
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-67wm3hhj.h264"
        ]
    },
    "3.1.1": {
        "name": "Up'nerkaq, Upenerkaq -- Spring",
        "url": "Upnerkaq-Upenerkaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-09w0vx3c.h264",
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-63fxpxg0.h264"
        ]
    },
    "3.1.2": {
        "name": "Uksuaq -- Fall",
        "url": "Uksuaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-00ns1t6z.h264",
            "cpb-aacip-127-33rv1b2m.h264",
            "cpb-aacip-127-67wm3hhj.h264"
        ]
    },
    "3.1.3": {
        "name": "Kiak -- Summer",
        "url": "Kiak",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-63fxpxg0.h264"
        ]
    },
    "3.2": {
        "name": "Ellaliuryaraq -- Predicting Weather",
        "url": "Ellaliuryaraq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-773txm5v.h264"
        ]
    },
    "3.2.1": {
        "name": "Ellassuun -- Weather Device",
        "url": "Ellassuun",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-28ncjzpp.h264"
        ]
    },
    "3.4": {
        "name": "Ciku -- Ice",
        "url": "Ciku",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-09w0vx3c.h264",
            "cpb-aacip-127-33rv1b2m.h264",
            "cpb-aacip-127-440rz436.h264",
            "cpb-aacip-127-752fr7q2.h264"
        ]
    },
    "3.4.1": {
        "name": "Kianeq -- Naturally Occurring Holes in Ice",
        "url": "Kianeq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-33rv1b2m.h264"
        ]
    },
    "3.5": {
        "name": "Qanikcaq -- Snow",
        "url": "Qanikcaq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-09w0vx3c.h264",
            "cpb-aacip-127-23612qck.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-752fr7q2.h264"
        ]
    },
    "3.5.1": {
        "name": "Urugyaraa -- Melting",
        "url": "Urugyaraa",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-752fr7q2.h264"
        ]
    },
    "3.6": {
        "name": "Iraluq -- Moon, Month",
        "url": "Iraluq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-63fxpxg0.h264"
        ]
    },
    "3.8": {
        "name": "Agyat -- Stars",
        "url": "Agyat",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-48ffbpfx.h264",
            "cpb-aacip-127-59c5b6gx.h264",
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-65h9w88k.h264"
        ]
    },
    "3.9": {
        "name": "Nunavut -- Our Land",
        "url": "Nunavut",
        "images": [],
        "children": 3,
        "videoNumbers": [
            "cpb-aacip-127-009w0z0q.h264",
            "cpb-aacip-127-10jsxpwg.h264",
            "cpb-aacip-127-15p8d31m.h264",
            "cpb-aacip-127-16pzgr3f.h264",
            "cpb-aacip-127-18rbp380.h264",
            "cpb-aacip-127-25x69tk3.h264",
            "cpb-aacip-127-26xwdh7k.h264",
            "cpb-aacip-127-74qjqbsc.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "3.9.1": {
        "name": "Uqlaneq -- Pollution",
        "url": "Uqlaneq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-009w0z0q.h264",
            "cpb-aacip-127-15p8d31m.h264",
            "cpb-aacip-127-18rbp380.h264",
            "cpb-aacip-127-25x69tk3.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "3.9.1.1": {
        "name": "Neqet Cumacitartut -- Fish are Repulsed by Pollution",
        "url": "Neqet-Cumacitartut",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "3.9.2": {
        "name": "Nunam Auluksaraa -- Taking Care of the Land",
        "url": "Nunam-Auluksaraa",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-74qjqbsc.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "3.9.2.1": {
        "name": "Menuunani -- Pristine",
        "url": "Menuunani",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "3.9.3": {
        "name": "Nunam Ataniuryaraa -- Land Governance",
        "url": "Nunam-Ataniuryaraa",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-74qjqbsc.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "3.10": {
        "name": "Ulerpak -- Flood",
        "url": "Ulerpak",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-09w0vx3c.h264"
        ]
    },
    "3.11": {
        "name": "Ellarrluk -- Good Weather Being Bad",
        "url": "Ellarrluk",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-719kdfjd.h264"
        ]
    },
    "3.12": {
        "name": "Qilagkun Sass'aq -- Measuring Time with the Sky",
        "url": "Qilagkun-Sassaq",
        "images": [],
        "children": 2,
        "videoNumbers": [
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-773txm5v.h264"
        ]
    },
    "3.12.1": {
        "name": "Akerta -- Sun",
        "url": "Akerta",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-773txm5v.h264"
        ]
    },
    "4": {
        "name": "Yuut -- People",
        "url": "Yuut",
        "images": [
            "Yuut.jpg"
        ],
        "children": 5,
        "videoNumbers": [
            "cpb-aacip-127-009w0z0q.h264",
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-14nk9d19.h264",
            "cpb-aacip-127-25k98x78.h264",
            "cpb-aacip-127-37vmd1rq.h264",
            "cpb-aacip-127-440rz436.h264",
            "cpb-aacip-127-53wstz0s.h264",
            "cpb-aacip-127-54kkwqvx.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-719kdf8m.h264",
            "cpb-aacip-127-87pnw7r9.h264",
            "cpb-aacip-127-89r22kjv.h264",
            "cpb-aacip-127-98mcvs0p.h264"
        ]
    },
    "4.1": {
        "name": "Ayagyuat -- Youth",
        "url": "Ayagyuat",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-25k98x78.h264",
            "cpb-aacip-127-53wstz0s.h264",
            "cpb-aacip-127-54kkwqvx.h264",
            "cpb-aacip-127-54kkwrd6.h264"
        ]
    },
    "4.2": {
        "name": "Tegganeq -- Elder",
        "url": "Tegganeq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-37vmd1rq.h264",
            "cpb-aacip-127-65h9w88k.h264"
        ]
    },
    "4.3": {
        "name": "Nukalpiaq -- Great Hunter",
        "url": "Nukalpiaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-14nk9d19.h264",
            "cpb-aacip-127-87pnw7r9.h264",
            "cpb-aacip-127-89r22kjv.h264"
        ]
    },
    "4.4": {
        "name": "Nengauk -- Son-in-law",
        "url": "Nengauk",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-009w0z0q.h264"
        ]
    },
    "4.5": {
        "name": "Elliraat -- Orphans",
        "url": "Elliraat",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-440rz436.h264",
            "cpb-aacip-127-719kdf8m.h264",
            "cpb-aacip-127-98mcvs0p.h264"
        ]
    },
    "5": {
        "name": "Ungungssit Mermiutaat-llu -- Land And Water Animals",
        "url": "Ungungssit-Mermiutaat-llu",
        "images": [
            "UngungssitMermiutaatllu.jpg"
        ],
        "children": 5,
        "videoNumbers": [
            "cpb-aacip-127-00ns1t6z.h264",
            "cpb-aacip-127-032282mq.h264",
            "cpb-aacip-127-03cz8zdq.h264",
            "cpb-aacip-127-06g1k008.h264",
            "cpb-aacip-127-085hqfqk.h264",
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-10jsxpwg.h264",
            "cpb-aacip-127-14nk9d19.h264",
            "cpb-aacip-127-20fttjr7.h264",
            "cpb-aacip-127-23612qck.h264",
            "cpb-aacip-127-25x69tk3.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-623bkbxr.h264",
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-65v6x4wh.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-81jhb5w6.h264",
            "cpb-aacip-127-881jx4d6.h264",
            "cpb-aacip-127-89280sv6.h264",
            "cpb-aacip-127-91sf7xm0.h264"
        ]
    },
    "5.1": {
        "name": "Neqa, Neqet -- Fish",
        "url": "Neqa-Neqet",
        "images": [],
        "children": 4,
        "videoNumbers": [
            "cpb-aacip-127-00ns1t6z.h264",
            "cpb-aacip-127-085hqfqk.h264",
            "cpb-aacip-127-25x69tk3.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-623bkbxr.h264",
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-881jx4d6.h264",
            "cpb-aacip-127-91sf7xm0.h264"
        ]
    },
    "5.1.1": {
        "name": "Can'giiq, Imangaq -- Blackfish",
        "url": "Cangiiq-Imangaq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-00ns1t6z.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-623bkbxr.h264",
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-719kdfjd.h264"
        ]
    },
    "5.1.1.1": {
        "name": "Alungyaraat -- Blackfish Fries",
        "url": "Alungyaraat",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-719kdfjd.h264"
        ]
    },
    "5.1.3": {
        "name": "Meluk, Imlauk -- Roe",
        "url": "Meluk-Imlauk",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-91sf7xm0.h264"
        ]
    },
    "5.2": {
        "name": "Yaqulek, Yaqulget, Tengmiaq, Tengmiat -- Birds",
        "url": "Yaqulek-Yaqulget-Tengmiaq-Tengmiat",
        "images": [],
        "children": 2,
        "videoNumbers": [
            "cpb-aacip-127-085hqfqk.h264",
            "cpb-aacip-127-10jsxpwg.h264",
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-752fr7q2.h264"
        ]
    },
    "5.2.1": {
        "name": "Qangqiiq -- Ptarmigan",
        "url": "Qangqiiq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-10jsxpwg.h264",
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-719kdfjd.h264"
        ]
    },
    "5.2.2": {
        "name": "Ingtaq, Ingtat -- Molted Birds",
        "url": "Ingtaq-Ingtat",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-63fxpxg0.h264"
        ]
    },
    "5.3": {
        "name": "Ungungssit, Yuilqurmiutaat, Nunamiutaat -- Land, Wilderness Animals",
        "url": "Ungungssit-Yuilqurmiutaat-Nunamiutaat",
        "images": [],
        "children": 10,
        "videoNumbers": [
            "cpb-aacip-127-00ns1t6z.h264",
            "cpb-aacip-127-03cz8zdq.h264",
            "cpb-aacip-127-06g1k008.h264",
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-10jsxpwg.h264",
            "cpb-aacip-127-14nk9d19.h264",
            "cpb-aacip-127-23612qck.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-81jhb5w6.h264",
            "cpb-aacip-127-89280sv6.h264"
        ]
    },
    "5.3.1": {
        "name": "Tuntu -- Reindeer, Caribou",
        "url": "Tuntu",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-03cz8zdq.h264",
            "cpb-aacip-127-14nk9d19.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-81jhb5w6.h264"
        ]
    },
    "5.3.2": {
        "name": "Imarmiutaq -- Mink",
        "url": "Imarmiutaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-00ns1t6z.h264",
            "cpb-aacip-127-23612qck.h264"
        ]
    },
    "5.3.3": {
        "name": "Kegluneq -- Wolf",
        "url": "Kegluneq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-03cz8zdq.h264"
        ]
    },
    "5.3.4": {
        "name": "Cuignilnguq -- Otter",
        "url": "Cuignilnguq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-00ns1t6z.h264",
            "cpb-aacip-127-23612qck.h264"
        ]
    },
    "5.3.6": {
        "name": "Tan'gerliq -- Black Bear",
        "url": "Tangerliq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-06g1k008.h264",
            "cpb-aacip-127-89280sv6.h264"
        ]
    },
    "5.3.7": {
        "name": "Taqukaq, Carayaq -- Brown Bear",
        "url": "Taqukaq-Carayaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-06g1k008.h264"
        ]
    },
    "5.3.8": {
        "name": "Qanganaq -- Ground Squirrel",
        "url": "Qanganaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-28ncjzpp.h264"
        ]
    },
    "5.3.9": {
        "name": "Tuntuvak -- Moose",
        "url": "Tuntuvak",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-66vx0v02.h264"
        ]
    },
    "5.3.10": {
        "name": "Tuntupik, Tuntupiaq -- Caribou",
        "url": "Tuntupik-Tuntupiaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-66vx0v02.h264"
        ]
    },
    "5.4": {
        "name": "Imarpigmiutaat, Unkumiutaat, Mermiutaat -- Marine Animals",
        "url": "Imarpigmiutaat-Unkumiutaat-Mermiutaat",
        "images": [],
        "children": 5,
        "videoNumbers": [
            "cpb-aacip-127-032282mq.h264",
            "cpb-aacip-127-085hqfqk.h264",
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-20fttjr7.h264",
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-65v6x4wh.h264",
            "cpb-aacip-127-752fr7q2.h264"
        ]
    },
    "5.4.1": {
        "name": "Maklak -- Bearded Seal",
        "url": "Maklak",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-20fttjr7.h264",
            "cpb-aacip-127-63fxpxg0.h264"
        ]
    },
    "5.4.2": {
        "name": "Nayiq -- Ringed Seal",
        "url": "Nayiq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-20fttjr7.h264"
        ]
    },
    "5.4.3": {
        "name": "Puga -- Surfaced Seal",
        "url": "Puga",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-10jsxpvr.h264"
        ]
    },
    "5.4.4": {
        "name": "Cetuaq -- Beluga",
        "url": "Cetuaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-085hqfqk.h264",
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-752fr7q2.h264"
        ]
    },
    "5.5": {
        "name": "Piyagaq -- Baby Animal",
        "url": "Piyagaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-06g1k008.h264",
            "cpb-aacip-127-10jsxpwg.h264",
            "cpb-aacip-127-63fxpxg0.h264"
        ]
    },
    "6": {
        "name": "Naunraat Atsat-llu -- Plants And Berries",
        "url": "Naunraat-Atsat-llu",
        "images": [
            "NaunraatAtsatllu.jpg"
        ],
        "children": 4,
        "videoNumbers": [
            "cpb-aacip-127-00ns1t6z.h264",
            "cpb-aacip-127-18rbp380.h264",
            "cpb-aacip-127-257d81kk.h264",
            "cpb-aacip-127-27zkh5wz.h264",
            "cpb-aacip-127-33rv1b2m.h264",
            "cpb-aacip-127-34sj40gx.h264",
            "cpb-aacip-127-42n5thvk.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-76f1vspw.h264",
            "cpb-aacip-127-805x6mnx.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "6.1": {
        "name": "Atsat -- Berries",
        "url": "Atsat",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-18rbp380.h264",
            "cpb-aacip-127-257d81kk.h264",
            "cpb-aacip-127-27zkh5wz.h264",
            "cpb-aacip-127-34sj40gx.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "6.2": {
        "name": "Naunraat -- Plants",
        "url": "Naunraat",
        "images": [],
        "children": 3,
        "videoNumbers": [
            "cpb-aacip-127-18rbp380.h264",
            "cpb-aacip-127-257d81kk.h264",
            "cpb-aacip-127-42n5thvk.h264"
        ]
    },
    "6.2.2": {
        "name": "Quagciq -- Sourdock",
        "url": "Quagciq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-257d81kk.h264",
            "cpb-aacip-127-42n5thvk.h264"
        ]
    },
    "6.2.3": {
        "name": "Uqviit, Enrilnguat -- Willows",
        "url": "Uqviit-Enrilnguat",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-42n5thvk.h264"
        ]
    },
    "6.3": {
        "name": "Canek, Can'get, Caranglluk, Evek -- Grass",
        "url": "Canek-Canget-Caranglluk-Evek",
        "images": [],
        "children": 9,
        "videoNumbers": [
            "cpb-aacip-127-00ns1t6z.h264",
            "cpb-aacip-127-33rv1b2m.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-76f1vspw.h264"
        ]
    },
    "6.3.4": {
        "name": "Iitaq -- Tall Cottongrass",
        "url": "Iitaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-69m37zr9.h264"
        ]
    },
    "6.3.5": {
        "name": "Kelugkaq -- Course Grass for Weaving Mats",
        "url": "Kelugkaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-66vx0v02.h264"
        ]
    },
    "6.3.6": {
        "name": "Issran -- Grass Backpack",
        "url": "Issran",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-66vx0v02.h264"
        ]
    },
    "6.3.7": {
        "name": "Kalngak -- Grass Bag for Fish",
        "url": "Kalngak",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-66vx0v02.h264"
        ]
    },
    "6.3.8": {
        "name": "Naqtat -- Grass Mats",
        "url": "Naqtat",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-76f1vspw.h264"
        ]
    },
    "6.4": {
        "name": "Naucetaat -- Crops",
        "url": "Naucetaat",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-719kdfjd.h264"
        ]
    },
    "6.4.1": {
        "name": "Naucetaanek Enuqitellriit -- Crop Failure",
        "url": "Naucetaanek-Enuqitellriit",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-719kdfjd.h264"
        ]
    },
    "7": {
        "name": "Akluq, Aklut -- Clothing, Possessions",
        "url": "Akluq-Aklut",
        "images": [
            "AkluqAklut.jpg"
        ],
        "children": 5,
        "videoNumbers": [
            "cpb-aacip-127-00ns1t6z.h264",
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-10jsxpx6.h264",
            "cpb-aacip-127-322bvwfr.h264",
            "cpb-aacip-127-386hdxkk.h264",
            "cpb-aacip-127-6341p189.h264",
            "cpb-aacip-127-65v6x4wh.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-67wm3hhj.h264",
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "7.2": {
        "name": "Kass'artaat -- Manufactured Items",
        "url": "Kassartaat",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-10jsxpx6.h264"
        ]
    },
    "7.4": {
        "name": "Amiq, Qecik -- Skin, Hide",
        "url": "Amiq-Qecik",
        "images": [],
        "children": 2,
        "videoNumbers": [
            "cpb-aacip-127-00ns1t6z.h264",
            "cpb-aacip-127-65v6x4wh.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-67wm3hhj.h264"
        ]
    },
    "7.4.1": {
        "name": "Ivrucit -- Waterproof Skin Boots",
        "url": "Ivrucit",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-67wm3hhj.h264"
        ]
    },
    "7.4.2": {
        "name": "Amirak, Amiraq -- Waterproof Fish Skin Boots",
        "url": "Amirak-Amiraq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-67wm3hhj.h264"
        ]
    },
    "7.4.2.1": {
        "name": "Neqairiyaraq -- Preparing Fish Skin for Use",
        "url": "Neqairiyaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-67wm3hhj.h264"
        ]
    },
    "7.5": {
        "name": "Allat -- Other Clothes",
        "url": "Allat",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-6341p189.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "7.5.1": {
        "name": "Imarnin -- Seal Gut Rain Parka",
        "url": "Imarnin",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-6341p189.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "8": {
        "name": "Ukverput, Agayuliyaraq -- Spirituality",
        "url": "Ukverput-Agayuliyaraq",
        "images": [
            "UkverputAgayuliyaraq.jpg"
        ],
        "children": 6,
        "videoNumbers": [
            "cpb-aacip-127-03cz8zdq.h264",
            "cpb-aacip-127-0644j37r.h264",
            "cpb-aacip-127-06g1jzz6.h264",
            "cpb-aacip-127-06g1k008.h264",
            "cpb-aacip-127-14nk9d19.h264",
            "cpb-aacip-127-15p8d31m.h264",
            "cpb-aacip-127-257d81m9.h264",
            "cpb-aacip-127-25x69tk3.h264",
            "cpb-aacip-127-35t76q2k.h264",
            "cpb-aacip-127-37hqc4tk.h264",
            "cpb-aacip-127-37vmd1rq.h264",
            "cpb-aacip-127-386hdz1p.h264",
            "cpb-aacip-127-41mgqv1k.h264",
            "cpb-aacip-127-47rn8x0g.h264",
            "cpb-aacip-127-48ffbpfx.h264",
            "cpb-aacip-127-52j6qcr2.h264",
            "cpb-aacip-127-53wstz0s.h264",
            "cpb-aacip-127-54kkwqvx.h264",
            "cpb-aacip-127-57np5s39.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-74cnpfr2.h264",
            "cpb-aacip-127-74qjqbsc.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-76f1vspw.h264",
            "cpb-aacip-127-773txm5v.h264",
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-79h44thw.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-81jhb5w6.h264",
            "cpb-aacip-127-84mkm6tr.h264",
            "cpb-aacip-127-86nzsk0r.h264",
            "cpb-aacip-127-87brvbt5.h264",
            "cpb-aacip-127-87pnw7r9.h264",
            "cpb-aacip-127-881jx4d6.h264",
            "cpb-aacip-127-89280sv6.h264",
            "cpb-aacip-127-91sf7xm0.h264",
            "cpb-aacip-127-956djvkd.h264",
            "cpb-aacip-127-96wwq9xv.h264"
        ]
    },
    "8.1": {
        "name": "Agayumayaraq, Agayumaciq -- Christianity",
        "url": "Agayumayaraq-Agayumaciq",
        "images": [],
        "children": 5,
        "videoNumbers": [
            "cpb-aacip-127-0644j37r.h264",
            "cpb-aacip-127-14nk9d19.h264",
            "cpb-aacip-127-35t76q2k.h264",
            "cpb-aacip-127-41mgqv1k.h264",
            "cpb-aacip-127-47rn8x0g.h264",
            "cpb-aacip-127-53wstz0s.h264",
            "cpb-aacip-127-54kkwqvx.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-74cnpfr2.h264",
            "cpb-aacip-127-74qjqbsc.h264",
            "cpb-aacip-127-76f1vspw.h264",
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-79h44thw.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-81jhb5w6.h264",
            "cpb-aacip-127-84mkm6tr.h264",
            "cpb-aacip-127-87pnw7r9.h264",
            "cpb-aacip-127-881jx4d6.h264",
            "cpb-aacip-127-89280sv6.h264",
            "cpb-aacip-127-91sf7xm0.h264",
            "cpb-aacip-127-956djvkd.h264"
        ]
    },
    "8.1.1": {
        "name": "Agayuviit -- Churches",
        "url": "Agayuviit",
        "images": [],
        "children": 2,
        "videoNumbers": [
            "cpb-aacip-127-35t76q2k.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "8.1.1.1": {
        "name": "Moravian -- Moravian",
        "url": "Moravian",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "8.1.1.2": {
        "name": "Kass'alugpiaq -- Russian Orthodox",
        "url": "Kassalugpiaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-35t76q2k.h264"
        ]
    },
    "8.1.2": {
        "name": "Agayulirtet -- Priests",
        "url": "Agayulirtet",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-35t76q2k.h264",
            "cpb-aacip-127-47rn8x0g.h264",
            "cpb-aacip-127-74cnpfr2.h264",
            "cpb-aacip-127-81jhb5w6.h264"
        ]
    },
    "8.1.3": {
        "name": "Qaneryaraq, Qaneryaraqegtaar -- Bible",
        "url": "Qaneryaraq-Qaneryaraqegtaar",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-14nk9d19.h264",
            "cpb-aacip-127-54kkwqvx.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-74qjqbsc.h264",
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-81jhb5w6.h264",
            "cpb-aacip-127-84mkm6tr.h264",
            "cpb-aacip-127-87pnw7r9.h264"
        ]
    },
    "8.1.4": {
        "name": "Anglluryaraq -- Baptism",
        "url": "Anglluryaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-76f1vspw.h264"
        ]
    },
    "8.1.5": {
        "name": "Piicak -- Prayer",
        "url": "Piicak",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-0644j37r.h264",
            "cpb-aacip-127-41mgqv1k.h264",
            "cpb-aacip-127-53wstz0s.h264",
            "cpb-aacip-127-956djvkd.h264"
        ]
    },
    "8.2": {
        "name": "Ellam Yua, Cellam Yua, Cillam Cua -- Spirit Of The Universe",
        "url": "Ellam-Yua-Cellam-Yua-Cillam-Cua",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-15p8d31m.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-74cnpfr2.h264",
            "cpb-aacip-127-74qjqbsc.h264",
            "cpb-aacip-127-773txm5v.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-84mkm6tr.h264"
        ]
    },
    "8.3": {
        "name": "Piunrillret, Yuunrillret, Tuqullret, Catairutellret -- Afterlife",
        "url": "Piunrillret-Yuunrillret-Tuqullret-Catairutellret",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-25x69tk3.h264",
            "cpb-aacip-127-54kkwqvx.h264",
            "cpb-aacip-127-69m37zr9.h264"
        ]
    },
    "8.4": {
        "name": "Angalkut, Angalkuut -- Shamans",
        "url": "Angalkut-Angalkuut",
        "images": [],
        "children": 4,
        "videoNumbers": [
            "cpb-aacip-127-03cz8zdq.h264",
            "cpb-aacip-127-06g1k008.h264",
            "cpb-aacip-127-257d81m9.h264",
            "cpb-aacip-127-37hqc4tk.h264",
            "cpb-aacip-127-48ffbpfx.h264",
            "cpb-aacip-127-52j6qcr2.h264",
            "cpb-aacip-127-57np5s39.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-74cnpfr2.h264",
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-79h44thw.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-86nzsk0r.h264",
            "cpb-aacip-127-87brvbt5.h264",
            "cpb-aacip-127-89280sv6.h264"
        ]
    },
    "8.4.2": {
        "name": "Unatellget -- Healing Hands",
        "url": "Unatellget",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-52j6qcr2.h264",
            "cpb-aacip-127-87brvbt5.h264"
        ]
    },
    "8.4.3": {
        "name": "Tuunriyaraq, Angalkiyaraq -- Shamanistic Acts, Rituals",
        "url": "Tuunriyaraq-Angalkiyaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-52j6qcr2.h264",
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "8.4.4": {
        "name": "Umyuarrliqellriit -- Those with Malicious Intent",
        "url": "Umyuarrliqellriit",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-86nzsk0r.h264"
        ]
    },
    "8.4.4.1": {
        "name": "Aniqlaarutet -- Curses",
        "url": "Aniqlaarutet",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-86nzsk0r.h264"
        ]
    },
    "8.5": {
        "name": "Alangru, Aliurtuq -- Ghost, Haunting",
        "url": "Alangru-Aliurtuq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-06g1jzz6.h264",
            "cpb-aacip-127-752fr7q2.h264"
        ]
    },
    "8.5.1": {
        "name": "Qimugtet Elpegtauciatnek -- Dogs' Supernatural Sensitivity",
        "url": "Qimugtet-Elpegtauciatnek",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-752fr7q2.h264"
        ]
    },
    "8.6": {
        "name": "Aviukaryaraq -- Food And Water Offering",
        "url": "Aviukaryaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-15p8d31m.h264",
            "cpb-aacip-127-57np5s39.h264"
        ]
    },
    "9": {
        "name": "Nerangnaqsaraq, Yuungnaqsaraq -- Subsistence",
        "url": "Nerangnaqsaraq-Yuungnaqsaraq",
        "images": [
            "NerangnaqsaraqYuungnaqsaraq.jpg"
        ],
        "children": 13,
        "videoNumbers": [
            "cpb-aacip-127-00ns1t6z.h264",
            "cpb-aacip-127-03cz8zdq.h264",
            "cpb-aacip-127-0644j37r.h264",
            "cpb-aacip-127-085hqfqk.h264",
            "cpb-aacip-127-09w0vx3c.h264",
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-10jsxpwg.h264",
            "cpb-aacip-127-14nk9d19.h264",
            "cpb-aacip-127-16pzgr3f.h264",
            "cpb-aacip-127-18rbp380.h264",
            "cpb-aacip-127-20fttjr7.h264",
            "cpb-aacip-127-23612qck.h264",
            "cpb-aacip-127-257d81kk.h264",
            "cpb-aacip-127-257d81m9.h264",
            "cpb-aacip-127-27zkh5wz.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-322bvwfr.h264",
            "cpb-aacip-127-38w9gpk2.h264",
            "cpb-aacip-127-440rz436.h264",
            "cpb-aacip-127-48ffbpfx.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-59c5b6f6.h264",
            "cpb-aacip-127-59c5b6gx.h264",
            "cpb-aacip-127-59q2c3zn.h264",
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-65v6x4wh.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-719kdf8m.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-7634tx89.h264",
            "cpb-aacip-127-76f1vspw.h264",
            "cpb-aacip-127-773txm5v.h264",
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-85n8pw5n.h264",
            "cpb-aacip-127-86nzsk0r.h264",
            "cpb-aacip-127-87brvbt5.h264",
            "cpb-aacip-127-87pnw7r9.h264",
            "cpb-aacip-127-881jx4d6.h264",
            "cpb-aacip-127-89280sv6.h264",
            "cpb-aacip-127-945qg6jq.h264",
            "cpb-aacip-127-98mcvs0p.h264"
        ]
    },
    "9.1": {
        "name": "Pissuryaraq -- Hunting",
        "url": "Pissuryaraq",
        "images": [],
        "children": 2,
        "videoNumbers": [
            "cpb-aacip-127-20fttjr7.h264",
            "cpb-aacip-127-23612qck.h264",
            "cpb-aacip-127-257d81m9.h264",
            "cpb-aacip-127-48ffbpfx.h264",
            "cpb-aacip-127-59q2c3zn.h264",
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-85n8pw5n.h264",
            "cpb-aacip-127-87pnw7r9.h264",
            "cpb-aacip-127-89280sv6.h264"
        ]
    },
    "9.1.1": {
        "name": "Qamigaryaraq -- Spring Seal Hunting",
        "url": "Qamigaryaraq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-65h9w88k.h264"
        ]
    },
    "9.1.1.1": {
        "name": "Uurcaq -- Returning Seal Hunter with a Signaling Gaff",
        "url": "Uurcaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-65h9w88k.h264"
        ]
    },
    "9.1.2": {
        "name": "Yaqulecuarteggun Elitnauryaraq -- Practicing with Small Birds",
        "url": "Yaqulecuarteggun-Elitnauryaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-752fr7q2.h264"
        ]
    },
    "9.2": {
        "name": "Pingnatugyaraq -- Providing",
        "url": "Pingnatugyaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-0644j37r.h264",
            "cpb-aacip-127-20fttjr7.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-65v6x4wh.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-98mcvs0p.h264"
        ]
    },
    "9.3": {
        "name": "Neqsuryaraq -- Fishing",
        "url": "Neqsuryaraq",
        "images": [],
        "children": 3,
        "videoNumbers": [
            "cpb-aacip-127-38w9gpk2.h264",
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-719kdf8m.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-87pnw7r9.h264"
        ]
    },
    "9.3.1": {
        "name": "Kuvyat -- Drift Nets",
        "url": "Kuvyat",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-719kdf8m.h264"
        ]
    },
    "9.3.2": {
        "name": "Taluyat -- Fish Traps",
        "url": "Taluyat",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "9.3.3": {
        "name": "Qalut -- Dipnets",
        "url": "Qalut",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-719kdf8m.h264"
        ]
    },
    "9.4": {
        "name": "Melqulegcuryaraq -- Trapping",
        "url": "Melqulegcuryaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-03cz8zdq.h264",
            "cpb-aacip-127-65v6x4wh.h264",
            "cpb-aacip-127-7634tx89.h264"
        ]
    },
    "9.5": {
        "name": "Makirayaraq -- Gathering",
        "url": "Makirayaraq",
        "images": [],
        "children": 5,
        "videoNumbers": [
            "cpb-aacip-127-10jsxpwg.h264",
            "cpb-aacip-127-18rbp380.h264",
            "cpb-aacip-127-257d81kk.h264",
            "cpb-aacip-127-27zkh5wz.h264",
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-87brvbt5.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "9.5.1": {
        "name": "Iqvaryaraq -- Picking Berries",
        "url": "Iqvaryaraq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-10jsxpwg.h264",
            "cpb-aacip-127-18rbp380.h264",
            "cpb-aacip-127-257d81kk.h264",
            "cpb-aacip-127-27zkh5wz.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "9.5.1.1": {
        "name": "Tutmarpek'nani -- Do Not Step on Them",
        "url": "Tutmarpeknani",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "9.5.2": {
        "name": "Kayangussuq, Avuryaraq -- Egg Hunting",
        "url": "Kayangussuq-Avuryaraq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-10jsxpwg.h264",
            "cpb-aacip-127-63fxpxg0.h264"
        ]
    },
    "9.5.2.1": {
        "name": "Kayanguq -- Egg",
        "url": "Kayanguq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-10jsxpwg.h264",
            "cpb-aacip-127-63fxpxg0.h264"
        ]
    },
    "9.5.3": {
        "name": "Pakissaagyaraq -- Gathering from Vole Caches",
        "url": "Pakissaagyaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-18rbp380.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-87brvbt5.h264"
        ]
    },
    "9.5.4": {
        "name": "Naumalriit Inerquutngulriit -- Plants Warned Against",
        "url": "Naumalriit-Inerquutngulriit",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "9.6": {
        "name": "Calirpagyaraq -- Hard Work",
        "url": "Calirpagyaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-0644j37r.h264",
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-322bvwfr.h264",
            "cpb-aacip-127-38w9gpk2.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-59c5b6gx.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-7634tx89.h264",
            "cpb-aacip-127-76f1vspw.h264"
        ]
    },
    "9.7": {
        "name": "Up'nerkilleq -- Spring Camp",
        "url": "Upnerkilleq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-085hqfqk.h264",
            "cpb-aacip-127-09w0vx3c.h264",
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-257d81m9.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-322bvwfr.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-945qg6jq.h264"
        ]
    },
    "9.8": {
        "name": "Uksuilleq -- Winter Camp",
        "url": "Uksuilleq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-00ns1t6z.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-773txm5v.h264"
        ]
    },
    "9.9": {
        "name": "Neqlilleq, Neqlivik -- Fish Camp",
        "url": "Neqlilleq-Neqlivik",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-773txm5v.h264"
        ]
    },
    "9.10": {
        "name": "Neqkat Kenciksarait -- Reverence for Food Sources",
        "url": "Neqkat-Kenciksarait",
        "images": [],
        "children": 2,
        "videoNumbers": [
            "cpb-aacip-127-085hqfqk.h264",
            "cpb-aacip-127-18rbp380.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-86nzsk0r.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "9.10.1": {
        "name": "Quyakluki Ciuniurluki -- Gratefully Accept Them",
        "url": "Quyakluki-Ciuniurluki",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-86nzsk0r.h264"
        ]
    },
    "9.10.2": {
        "name": "Ilakuat Neqerrluut Qimugtet Neqkait -- Leftover Dried Fish as Dog Food",
        "url": "Ilakuat-Neqerrluut-Qimugtet-Neqkait",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "9.11": {
        "name": "Upaketaaryaraq -- Nomadic Lifestyle",
        "url": "Upaketaaryaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-87pnw7r9.h264"
        ]
    },
    "9.12": {
        "name": "Caanguararkanek Avuusqevkenaki -- Do Not Gather What Will Be Wasted",
        "url": "Caanguararkanek-Avuusqevkenaki",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-59c5b6f6.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "9.13": {
        "name": "Tekitarkaq Umyuaqerrlainallruat -- They Always Prepared for the Future",
        "url": "Tekitarkaq-Umyuaqerrlainallruat",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-54kkwrd6.h264"
        ]
    },
    "10": {
        "name": "Neqkiuryaraq -- Food Preparation",
        "url": "Neqkiuryaraq",
        "images": [
            "Neqkiuryaraq.jpg"
        ],
        "children": 13,
        "videoNumbers": [
            "cpb-aacip-127-09w0vx3c.h264",
            "cpb-aacip-127-257d81kk.h264",
            "cpb-aacip-127-27zkh5wz.h264",
            "cpb-aacip-127-322bvwfr.h264",
            "cpb-aacip-127-34sj40gx.h264",
            "cpb-aacip-127-48ffbpfx.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-57np5s39.h264",
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-719kdf8m.h264",
            "cpb-aacip-127-74cnpfqb.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-773txm5v.h264",
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "10.1": {
        "name": "Keniryaraq, Egayaraq -- Cooking",
        "url": "Keniryaraq-Egayaraq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-34sj40gx.h264",
            "cpb-aacip-127-57np5s39.h264",
            "cpb-aacip-127-63fxpxg0.h264"
        ]
    },
    "10.1.1": {
        "name": "Assaliaq -- Frybread, Pancake",
        "url": "Assaliaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-34sj40gx.h264"
        ]
    },
    "10.2": {
        "name": "Segyaraq, Cegyaraq -- Fish Cutting",
        "url": "Segyaraq-Cegyaraq",
        "images": [],
        "children": 2,
        "videoNumbers": [
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "10.2.1": {
        "name": "Akerciurcecuunaki -- Not Letting Them Stay in the Sun",
        "url": "Akerciurcecuunaki",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-66vx0v02.h264"
        ]
    },
    "10.2.2": {
        "name": "Piqertuutarpek'naki -- Do Not Chop Them with an Axe",
        "url": "Piqertuutarpeknaki",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "10.3": {
        "name": "Kinerciriyaraq -- Drying",
        "url": "Kinerciriyaraq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "10.3.1": {
        "name": "Nakaculiyaraq -- Hanging Small Birds to Dry",
        "url": "Nakaculiyaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "10.5": {
        "name": "Qemagciyaraq -- Storage",
        "url": "Qemagciyaraq",
        "images": [],
        "children": 2,
        "videoNumbers": [
            "cpb-aacip-127-09w0vx3c.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-719kdf8m.h264",
            "cpb-aacip-127-74cnpfqb.h264",
            "cpb-aacip-127-784j17vw.h264"
        ]
    },
    "10.5.1": {
        "name": "Kumlivik -- Freezer",
        "url": "Kumlivik",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-09w0vx3c.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-784j17vw.h264"
        ]
    },
    "10.5.2": {
        "name": "Elagyat, Elliviit, Mamterat -- Food Caches",
        "url": "Elagyat-Elliviit-Mamterat",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-66vx0v02.h264"
        ]
    },
    "10.7": {
        "name": "Suluniyaraq, Culuniyaraq -- Salt Curing",
        "url": "Suluniyaraq-Culuniyaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-65h9w88k.h264"
        ]
    },
    "10.9": {
        "name": "Akutaq -- Akutaq (\"Eskimo Ice Cream\")",
        "url": "Akutaq",
        "images": [],
        "children": 4,
        "videoNumbers": [
            "cpb-aacip-127-257d81kk.h264",
            "cpb-aacip-127-27zkh5wz.h264",
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "10.9.1": {
        "name": "Tenguggluk -- Fish Liver Akutaq",
        "url": "Tenguggluk",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-27zkh5wz.h264"
        ]
    },
    "10.9.2": {
        "name": "Qerpertaq -- Pike Egg Akutaq",
        "url": "Qerpertaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-257d81kk.h264",
            "cpb-aacip-127-27zkh5wz.h264"
        ]
    },
    "10.9.3": {
        "name": "Tunuq -- Tallow",
        "url": "Tunuq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-257d81kk.h264",
            "cpb-aacip-127-784j17vw.h264"
        ]
    },
    "10.9.4": {
        "name": "Puya -- Moss Soaked in Seal Oil with Berries",
        "url": "Puya",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "10.10": {
        "name": "Ungangkengaita Auluksarait -- Taking Care of Catch",
        "url": "Ungangkengaita-Auluksarait",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-322bvwfr.h264",
            "cpb-aacip-127-48ffbpfx.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-69m37zr9.h264"
        ]
    },
    "10.11": {
        "name": "Aulukumanrilnguut Assiirutarkauciat -- Neglected Food Will Spoil",
        "url": "Aulukumanrilnguut-Assiirutarkauciat",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-74cnpfqb.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "10.12": {
        "name": "Neqallret -- Scraps",
        "url": "Neqallret",
        "images": [],
        "children": 3,
        "videoNumbers": [
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-74cnpfqb.h264",
            "cpb-aacip-127-773txm5v.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "10.12.1": {
        "name": "Tutmarngailngurmun Ciqicarait -- Disposal Where People Won't Trod",
        "url": "Tutmarngailngurmun-Ciqicarait",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-74cnpfqb.h264",
            "cpb-aacip-127-773txm5v.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "11": {
        "name": "Anangnaqsaraq Yuilqumi -- Survival (Wilderness)",
        "url": "Anangnaqsaraq-Yuilqumi",
        "images": [
            "AnangnaqsaraqYuilqumi.jpg"
        ],
        "children": 10,
        "videoNumbers": [
            "cpb-aacip-127-032282mq.h264",
            "cpb-aacip-127-06g1jzz6.h264",
            "cpb-aacip-127-085hqfqk.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-322bvwfr.h264",
            "cpb-aacip-127-33rv1b2m.h264",
            "cpb-aacip-127-42n5thvk.h264",
            "cpb-aacip-127-440rz436.h264",
            "cpb-aacip-127-46254fdx.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-74cnpfr2.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-81jhb5w6.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "11.1": {
        "name": "Qercuaneq, Qercualleq -- Frostbite",
        "url": "Qercuaneq-Qercualleq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-42n5thvk.h264"
        ]
    },
    "11.2": {
        "name": "Kit'elleq -- Falling Into Water",
        "url": "Kitelleq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-085hqfqk.h264",
            "cpb-aacip-127-33rv1b2m.h264",
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-74cnpfr2.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "11.2.1": {
        "name": "Pugtassuutet, Kit'essuutet -- Floatation Devices, Life Jackets",
        "url": "Pugtassuutet-Kitessuutet",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "11.3": {
        "name": "Pellaalleq -- Getting Lost",
        "url": "Pellaalleq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-085hqfqk.h264",
            "cpb-aacip-127-33rv1b2m.h264",
            "cpb-aacip-127-440rz436.h264",
            "cpb-aacip-127-63fxpxg0.h264"
        ]
    },
    "11.4": {
        "name": "Neqkaitelleq -- Having No Food",
        "url": "Neqkaitelleq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-085hqfqk.h264",
            "cpb-aacip-127-63fxpxg0.h264"
        ]
    },
    "11.5": {
        "name": "Meqsugyaraq -- Thirst",
        "url": "Meqsugyaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-085hqfqk.h264",
            "cpb-aacip-127-63fxpxg0.h264"
        ]
    },
    "11.6": {
        "name": "Ayagayaraq -- Travel",
        "url": "Ayagayaraq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-032282mq.h264",
            "cpb-aacip-127-322bvwfr.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "11.6.1": {
        "name": "Ayakatalriani Upcaraq -- Preparation for Travels",
        "url": "Ayakatalriani-Upcaraq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "11.6.1.1": {
        "name": "Taquat -- Provisions",
        "url": "Taquat",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-66vx0v02.h264"
        ]
    },
    "11.7": {
        "name": "Ellaliurcuutet -- Rain Gear",
        "url": "Ellaliurcuutet",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "11.8": {
        "name": "Pirtuk, Pirta -- Blizzard",
        "url": "Pirtuk-Pirta",
        "images": [],
        "children": 5,
        "videoNumbers": [
            "cpb-aacip-127-46254fdx.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-81jhb5w6.h264"
        ]
    },
    "11.8.1": {
        "name": "Uqisvik -- Shelter",
        "url": "Uqisvik",
        "images": [],
        "children": 2,
        "videoNumbers": [
            "cpb-aacip-127-46254fdx.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "11.8.1.1": {
        "name": "Qengaruk -- Snowbank",
        "url": "Qengaruk",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "11.8.1.2": {
        "name": "Murak Kapulluku Ellvilisqelluku -- Stick a Staff in for Ventilation",
        "url": "Murak-Kapulluku-Ellvilisqelluku",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-46254fdx.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "11.8.2": {
        "name": "Uqrem Aarnarqucia -- The Danger of Leeward Sides",
        "url": "Uqrem-Aarnarqucia",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "11.8.3": {
        "name": "Qanikcaam Acian Epsalngunarqucia -- Suffocating Under Snow",
        "url": "Qanikcaam-Acian-Epsalngunarqucia",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-752fr7q2.h264"
        ]
    },
    "11.8.4": {
        "name": "Utetmun Nallunailkuciryaraq -- Marking the Homeward Direction",
        "url": "Utetmun-Nallunailkuciryaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-752fr7q2.h264"
        ]
    },
    "11.8.5": {
        "name": "Naqugun -- Belt",
        "url": "Naqugun",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-81jhb5w6.h264"
        ]
    },
    "11.9": {
        "name": "Qerruyaraq -- Freezing to Death",
        "url": "Qerruyaraq",
        "images": [],
        "children": 2,
        "videoNumbers": [
            "cpb-aacip-127-752fr7q2.h264"
        ]
    },
    "11.9.1": {
        "name": "Teq'um Urumanarqucia -- Keeping Warm with Urine",
        "url": "Tequm-Urumanarqucia",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-752fr7q2.h264"
        ]
    },
    "11.9.2": {
        "name": "Qerruqatalriit Puqlamun Pivkenaki -- Do Not Put Hypothermic People Near Heat",
        "url": "Qerruqatalriit-Puqlamun-Pivkenaki",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-752fr7q2.h264"
        ]
    },
    "11.10": {
        "name": "Nuussiq, Cavik, Uluaq -- Knife",
        "url": "Nuussiq-Cavik-Uluaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-81jhb5w6.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "12": {
        "name": "Imarpik -- Ocean, Sea",
        "url": "Imarpik",
        "images": [
            "Imarpik.jpg"
        ],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-20fttjr7.h264",
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-74cnpfr2.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "12.1": {
        "name": "Imarpigmi Anangnaqsaraq -- Survival (Ocean)",
        "url": "Imarpigmi-Anangnaqsaraq",
        "images": [],
        "children": 3,
        "videoNumbers": [
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-74cnpfr2.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "12.1.1": {
        "name": "Elegcik -- Gaff",
        "url": "Elegcik",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-65h9w88k.h264"
        ]
    },
    "12.1.2": {
        "name": "Ket'garyaraq -- Waterproofing a Kayak with a Rain Parka",
        "url": "Ketgaryaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "12.1.3": {
        "name": "Pugtautet -- Life Vests, Floatation Devices",
        "url": "Pugtautet",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-719kdfjd.h264"
        ]
    },
    "13": {
        "name": "Tuqu Naulluun-llu, Qenan-llu -- Death & Sickness",
        "url": "Tuqu-Naulluun-llu-Qenan-llu",
        "images": [
            "TuquNaulluunlluQenanllu.jpg"
        ],
        "children": 4,
        "videoNumbers": [
            "cpb-aacip-127-032282mq.h264",
            "cpb-aacip-127-085hqfqk.h264",
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-25x69tk3.h264",
            "cpb-aacip-127-34fn33pp.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-623bkbxr.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-805x6mnx.h264",
            "cpb-aacip-127-87brvbt5.h264",
            "cpb-aacip-127-96wwq9xv.h264"
        ]
    },
    "13.1": {
        "name": "Tungmagciyaraq -- Burial",
        "url": "Tungmagciyaraq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-10jsxpvr.h264"
        ]
    },
    "13.1.1": {
        "name": "Qunguq -- Burial, Grave",
        "url": "Qunguq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-10jsxpvr.h264"
        ]
    },
    "13.2": {
        "name": "Cangerlak -- Pandemic, Epidemic",
        "url": "Cangerlak",
        "images": [],
        "children": 2,
        "videoNumbers": [
            "cpb-aacip-127-87brvbt5.h264"
        ]
    },
    "13.2.1": {
        "name": "Quserpak -- Tuberculosis (TB)",
        "url": "Quserpak",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-87brvbt5.h264"
        ]
    },
    "13.3": {
        "name": "Kaignaq, Piitnaq -- Time of Hunger, Need",
        "url": "Kaignaq-Piitnaq",
        "images": [],
        "children": 6,
        "videoNumbers": [
            "cpb-aacip-127-085hqfqk.h264",
            "cpb-aacip-127-623bkbxr.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-96wwq9xv.h264"
        ]
    },
    "13.3.1": {
        "name": "Enurnaq -- Scarcity",
        "url": "Enurnaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-085hqfqk.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-96wwq9xv.h264"
        ]
    },
    "13.3.2": {
        "name": "Nallunailkutet -- Preceding Signs",
        "url": "Nallunailkutet",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-719kdfjd.h264"
        ]
    },
    "13.3.3": {
        "name": "Angucaluq -- Late Summer",
        "url": "Angucaluq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-719kdfjd.h264"
        ]
    },
    "13.3.4": {
        "name": "Arnacaluq -- Early Summer",
        "url": "Arnacaluq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-719kdfjd.h264"
        ]
    },
    "13.3.5": {
        "name": "Ellam Qupsaraa -- The World, Universe Cracks",
        "url": "Ellam-Qupsaraa",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-719kdfjd.h264"
        ]
    },
    "13.3.6": {
        "name": "Ayuquciita Puglauciat -- Their Natures Showing",
        "url": "Ayuquciita-Puglauciat",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-784j17vw.h264"
        ]
    },
    "13.4": {
        "name": "Tuquiyaraq, Nepliayaraq -- Mourning",
        "url": "Tuquiyaraq-Nepliayaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-719kdfjd.h264"
        ]
    },
    "14": {
        "name": "Aipangyaraq, Aipaqsaraq -- Marriage",
        "url": "Aipangyaraq-Aipaqsaraq",
        "images": [
            "AipangyaraqAipaqsaraq.jpg"
        ],
        "children": 7,
        "videoNumbers": [
            "cpb-aacip-127-10jsxpx6.h264",
            "cpb-aacip-127-149p8hcz.h264",
            "cpb-aacip-127-225b014v.h264",
            "cpb-aacip-127-257d81m9.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-2908kvc9.h264",
            "cpb-aacip-127-322bvwfr.h264",
            "cpb-aacip-127-34fn33pp.h264",
            "cpb-aacip-127-386hdxkk.h264",
            "cpb-aacip-127-46254fdx.h264",
            "cpb-aacip-127-52j6qcr2.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-59c5b6f6.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-7634tx89.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-86nzsk0r.h264",
            "cpb-aacip-127-89280sv6.h264"
        ]
    },
    "14.1": {
        "name": "Uingyaraq -- How To Work With A Husband",
        "url": "Uingyaraq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-225b014v.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-7634tx89.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "14.1.1": {
        "name": "Nengaugicaraq -- Husband Marrying Into Another Village",
        "url": "Nengaugicaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-7634tx89.h264"
        ]
    },
    "14.2": {
        "name": "Nuliangyaraq, Nulirturyaraq -- How To Work With A Wife",
        "url": "Nuliangyaraq-Nulirturyaraq",
        "images": [],
        "children": 2,
        "videoNumbers": [
            "cpb-aacip-127-2908kvc9.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-7634tx89.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "14.2.1": {
        "name": "Nuliarkameng Akiliutait -- Brideswealth, Bride Price, Bride Token",
        "url": "Nuliarkameng-Akiliutait",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-7634tx89.h264"
        ]
    },
    "14.2.2": {
        "name": "Ukurricaraq -- Wife Marrying Into Another Village",
        "url": "Ukurricaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-54kkwrd6.h264"
        ]
    },
    "14.3": {
        "name": "Aipangyaraq -- Getting A Spouse",
        "url": "Aipangyaraq",
        "images": [],
        "children": 2,
        "videoNumbers": [
            "cpb-aacip-127-10jsxpx6.h264",
            "cpb-aacip-127-149p8hcz.h264",
            "cpb-aacip-127-225b014v.h264",
            "cpb-aacip-127-257d81m9.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-34fn33pp.h264",
            "cpb-aacip-127-59c5b6f6.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-7634tx89.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-86nzsk0r.h264"
        ]
    },
    "14.3.1": {
        "name": "Angayuqrita Cucukekaitnek Aipangyaraq -- Arranged Marriage",
        "url": "Angayuqrita-Cucukekaitnek-Aipangyaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-225b014v.h264",
            "cpb-aacip-127-257d81m9.h264",
            "cpb-aacip-127-59c5b6f6.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-7634tx89.h264"
        ]
    },
    "14.3.2": {
        "name": "Umyuallguteklutek -- Being in Harmony",
        "url": "Umyuallguteklutek",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-149p8hcz.h264",
            "cpb-aacip-127-34fn33pp.h264"
        ]
    },
    "14.4": {
        "name": "Avvucaraq -- Divorce",
        "url": "Avvucaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-225b014v.h264",
            "cpb-aacip-127-28ncjzpp.h264"
        ]
    },
    "14.5": {
        "name": "Yagirayaram Inerquutngucia -- Admonishments Against Raising Hands",
        "url": "Yagirayaram-Inerquutngucia",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-7634tx89.h264"
        ]
    },
    "14.6": {
        "name": "Qingaryaraq -- Pregnancy",
        "url": "Qingaryaraq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-7634tx89.h264",
            "cpb-aacip-127-89280sv6.h264"
        ]
    },
    "14.6.1": {
        "name": "Irniyaraq -- Childbirth",
        "url": "Irniyaraq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-7634tx89.h264",
            "cpb-aacip-127-89280sv6.h264"
        ]
    },
    "14.7": {
        "name": "Allaliuryaraq -- Infidelity",
        "url": "Allaliuryaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-86nzsk0r.h264"
        ]
    },
    "15": {
        "name": "Qulirat, Quliraat & Qanemcit -- Legends & Stories",
        "url": "Qulirat-Quliraat-Qanemcit",
        "images": [
            "QuliratQuliraatQanemcit.jpg"
        ],
        "children": 4,
        "videoNumbers": [
            "cpb-aacip-127-010p2r15.h264",
            "cpb-aacip-127-06g1jzz6.h264",
            "cpb-aacip-127-14nk9d19.h264",
            "cpb-aacip-127-257d81m9.h264",
            "cpb-aacip-127-25k98x78.h264",
            "cpb-aacip-127-27zkh5wz.h264",
            "cpb-aacip-127-34sj40gx.h264",
            "cpb-aacip-127-35gb5sdj.h264",
            "cpb-aacip-127-386hdz1p.h264",
            "cpb-aacip-127-59q2c3zn.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-81jhb5w6.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "15.1": {
        "name": "Ak'allaat Qanemcit -- Old Stories",
        "url": "Akallaat-Qanemcit",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-14nk9d19.h264",
            "cpb-aacip-127-257d81m9.h264",
            "cpb-aacip-127-386hdz1p.h264"
        ]
    },
    "15.1.1": {
        "name": "Anguyallret -- Old Wars",
        "url": "Anguyallret",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-14nk9d19.h264"
        ]
    },
    "15.2": {
        "name": "Ukaqvallaat Qanemcit -- Recent Stories",
        "url": "Ukaqvallaat-Qanemcit",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-010p2r15.h264",
            "cpb-aacip-127-06g1jzz6.h264",
            "cpb-aacip-127-25k98x78.h264",
            "cpb-aacip-127-27zkh5wz.h264",
            "cpb-aacip-127-34sj40gx.h264",
            "cpb-aacip-127-81jhb5w6.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "15.2.1": {
        "name": "Tunciuryaraq -- Reindeer Herding",
        "url": "Tunciuryaraq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-81jhb5w6.h264"
        ]
    },
    "15.2.1.1": {
        "name": "Nallunailkutet -- Brands",
        "url": "Nallunailkutet",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-81jhb5w6.h264"
        ]
    },
    "15.3": {
        "name": "Qulirat, Quliraat -- Legends",
        "url": "Qulirat-Quliraat",
        "images": [],
        "children": 3,
        "videoNumbers": [
            "cpb-aacip-127-257d81m9.h264",
            "cpb-aacip-127-35gb5sdj.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-784j17vw.h264"
        ]
    },
    "15.3.1": {
        "name": "Ircenrraat -- Legendary Little People [Mischievous]",
        "url": "Ircenrraat",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-257d81m9.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-784j17vw.h264"
        ]
    },
    "15.3.1.1": {
        "name": "Cautaita Ciunerkiurutait -- Their Things Portend the Future",
        "url": "Cautaita-Ciunerkiurutait",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-257d81m9.h264",
            "cpb-aacip-127-784j17vw.h264"
        ]
    },
    "15.3.2": {
        "name": "Egacuayiit -- Legendary Little People",
        "url": "Egacuayiit",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-66vx0v02.h264"
        ]
    },
    "15.4": {
        "name": "Carayiit -- Strange Creatures",
        "url": "Carayiit",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-59q2c3zn.h264"
        ]
    },
    "16": {
        "name": "Kass'artaat -- Manufactured Items, Western Things",
        "url": "Kassartaat",
        "images": [
            "Kassartaat.jpg"
        ],
        "children": 5,
        "videoNumbers": [
            "cpb-aacip-127-03cz8zdq.h264",
            "cpb-aacip-127-0644j37r.h264",
            "cpb-aacip-127-10jsxpx6.h264",
            "cpb-aacip-127-14nk9d19.h264",
            "cpb-aacip-127-16pzgr3f.h264",
            "cpb-aacip-127-225b014v.h264",
            "cpb-aacip-127-25k98x78.h264",
            "cpb-aacip-127-2908kvc9.h264",
            "cpb-aacip-127-322bvwfr.h264",
            "cpb-aacip-127-37hqc4tk.h264",
            "cpb-aacip-127-38w9gpk2.h264",
            "cpb-aacip-127-48ffbpfx.h264",
            "cpb-aacip-127-53wstz0s.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-60qrfsqn.h264",
            "cpb-aacip-127-67wm3hhj.h264",
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-719kdf8m.h264",
            "cpb-aacip-127-74cnpfqb.h264",
            "cpb-aacip-127-74qjqbsc.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-7634tx89.h264",
            "cpb-aacip-127-76f1vspw.h264",
            "cpb-aacip-127-773txm5v.h264",
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-85n8pw5n.h264",
            "cpb-aacip-127-86nzsk0r.h264",
            "cpb-aacip-127-87pnw7r9.h264",
            "cpb-aacip-127-89r22kjv.h264",
            "cpb-aacip-127-945qg6jq.h264"
        ]
    },
    "16.1": {
        "name": "Kass'at Tekipailgata -- Before Western Contact",
        "url": "Kassat-Tekipailgata",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-38w9gpk2.h264",
            "cpb-aacip-127-53wstz0s.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-719kdf8m.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-7634tx89.h264",
            "cpb-aacip-127-76f1vspw.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "16.1.1": {
        "name": "Nepiaq, Enepiaq, Enpiaq -- Sod-house",
        "url": "Nepiaq-Enepiaq-Enpiaq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-38w9gpk2.h264",
            "cpb-aacip-127-53wstz0s.h264",
            "cpb-aacip-127-719kdf8m.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-76f1vspw.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "16.1.1.1": {
        "name": "Qacarneret -- Walls",
        "url": "Qacarneret",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-76f1vspw.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "16.2": {
        "name": "Kass'at Tekiteqerraallratni -- Early Western Contact",
        "url": "Kassat-Tekiteqerraallratni",
        "images": [],
        "children": 5,
        "videoNumbers": [
            "cpb-aacip-127-03cz8zdq.h264",
            "cpb-aacip-127-10jsxpx6.h264",
            "cpb-aacip-127-14nk9d19.h264",
            "cpb-aacip-127-16pzgr3f.h264",
            "cpb-aacip-127-25k98x78.h264",
            "cpb-aacip-127-322bvwfr.h264",
            "cpb-aacip-127-37hqc4tk.h264",
            "cpb-aacip-127-38w9gpk2.h264",
            "cpb-aacip-127-48ffbpfx.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-74cnpfqb.h264",
            "cpb-aacip-127-76f1vspw.h264",
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-85n8pw5n.h264",
            "cpb-aacip-127-86nzsk0r.h264",
            "cpb-aacip-127-87pnw7r9.h264",
            "cpb-aacip-127-89r22kjv.h264",
            "cpb-aacip-127-945qg6jq.h264"
        ]
    },
    "16.2.1": {
        "name": "Yupiit (Allat-llu) Nunautait -- Native Allotment",
        "url": "Yupiit-(Allat-llu)-Nunautait",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-16pzgr3f.h264"
        ]
    },
    "16.2.2": {
        "name": "Elitnaurvikarraat -- Boarding Schools, First Schools",
        "url": "Elitnaurvikarraat",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-48ffbpfx.h264",
            "cpb-aacip-127-85n8pw5n.h264",
            "cpb-aacip-127-86nzsk0r.h264",
            "cpb-aacip-127-87pnw7r9.h264",
            "cpb-aacip-127-89r22kjv.h264"
        ]
    },
    "16.2.2.1": {
        "name": "Yugtun Qalartesqevkenaki -- Yup'ik Language Restrictions",
        "url": "Yugtun-Qalartesqevkenaki",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-85n8pw5n.h264"
        ]
    },
    "16.2.3": {
        "name": "Tunciuryaraq -- Reindeer Herding",
        "url": "Tunciuryaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-03cz8zdq.h264",
            "cpb-aacip-127-14nk9d19.h264"
        ]
    },
    "16.2.4": {
        "name": "Sun'aq -- Ship, Barge",
        "url": "Sunaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-10jsxpx6.h264",
            "cpb-aacip-127-37hqc4tk.h264"
        ]
    },
    "16.2.5": {
        "name": "Levaat, Massiinat, Elliqeryarat -- Boat Motors",
        "url": "Levaat-Massiinat-Elliqeryarat",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "16.3": {
        "name": "Aklut -- Clothes, Possessions",
        "url": "Aklut",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-2908kvc9.h264",
            "cpb-aacip-127-752fr7q2.h264"
        ]
    },
    "16.4": {
        "name": "Elitnaurvik -- School",
        "url": "Elitnaurvik",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-14nk9d19.h264",
            "cpb-aacip-127-225b014v.h264",
            "cpb-aacip-127-2908kvc9.h264",
            "cpb-aacip-127-60qrfsqn.h264",
            "cpb-aacip-127-74qjqbsc.h264",
            "cpb-aacip-127-7634tx89.h264",
            "cpb-aacip-127-76f1vspw.h264",
            "cpb-aacip-127-773txm5v.h264",
            "cpb-aacip-127-85n8pw5n.h264",
            "cpb-aacip-127-86nzsk0r.h264",
            "cpb-aacip-127-87pnw7r9.h264"
        ]
    },
    "16.4.1": {
        "name": "Yugtun Kass'atun-llu Elitnauryaraq -- Bilingual Education",
        "url": "Yugtun-Kassatun-llu-Elitnauryaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-60qrfsqn.h264",
            "cpb-aacip-127-85n8pw5n.h264"
        ]
    },
    "16.5": {
        "name": "Kipusviit -- Trading Posts, Stores",
        "url": "Kipusviit",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-0644j37r.h264",
            "cpb-aacip-127-719kdf8m.h264",
            "cpb-aacip-127-773txm5v.h264"
        ]
    },
    "17": {
        "name": "Pissuutet, Cassuutet, Piliat, Saskut, Ayagassuutet -- Tools, Crafts, Weapons",
        "url": "Pissuutet-Cassuutet-Piliat-Saskut-Ayagassuutet",
        "images": [
            "PissuutetCassuutetPiliatSaskutAyagassuutet.jpg"
        ],
        "children": 8,
        "videoNumbers": [
            "cpb-aacip-127-00ns1t6z.h264",
            "cpb-aacip-127-03cz8zdq.h264",
            "cpb-aacip-127-06g1jzz6.h264",
            "cpb-aacip-127-06g1k008.h264",
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-10jsxpwg.h264",
            "cpb-aacip-127-14nk9d19.h264",
            "cpb-aacip-127-20fttjr7.h264",
            "cpb-aacip-127-23612qck.h264",
            "cpb-aacip-127-257d81kk.h264",
            "cpb-aacip-127-33rv1b2m.h264",
            "cpb-aacip-127-440rz436.h264",
            "cpb-aacip-127-46254fdx.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-60qrfsqn.h264",
            "cpb-aacip-127-623bkbxr.h264",
            "cpb-aacip-127-6341p189.h264",
            "cpb-aacip-127-65v6x4wh.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-67wm3hhj.h264",
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-719kdf8m.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-76f1vspw.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "17.1": {
        "name": "Cassuutet Saskut, Caskut -- Tools",
        "url": "Cassuutet-Saskut-Caskut",
        "images": [],
        "children": 7,
        "videoNumbers": [
            "cpb-aacip-127-00ns1t6z.h264",
            "cpb-aacip-127-03cz8zdq.h264",
            "cpb-aacip-127-06g1k008.h264",
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-10jsxpwg.h264",
            "cpb-aacip-127-14nk9d19.h264",
            "cpb-aacip-127-23612qck.h264",
            "cpb-aacip-127-33rv1b2m.h264",
            "cpb-aacip-127-440rz436.h264",
            "cpb-aacip-127-46254fdx.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-60qrfsqn.h264",
            "cpb-aacip-127-623bkbxr.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-67wm3hhj.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "17.1.1": {
        "name": "Ayaruq -- Walking Stick, Cane, Staff",
        "url": "Ayaruq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-03cz8zdq.h264",
            "cpb-aacip-127-06g1k008.h264",
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-14nk9d19.h264",
            "cpb-aacip-127-33rv1b2m.h264",
            "cpb-aacip-127-60qrfsqn.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "17.1.2": {
        "name": "Cikuliurun, Tugeq -- Ice Spud, Ice Pick, Ice Chisel",
        "url": "Cikuliurun-Tugeq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-440rz436.h264",
            "cpb-aacip-127-46254fdx.h264",
            "cpb-aacip-127-623bkbxr.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "17.1.3": {
        "name": "Negaq -- Snare, Trap",
        "url": "Negaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-10jsxpwg.h264"
        ]
    },
    "17.1.5": {
        "name": "Kapkaanaq -- Conibear, Steel Trap",
        "url": "Kapkaanaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-66vx0v02.h264"
        ]
    },
    "17.1.6": {
        "name": "Taluyaq -- Fish Trap",
        "url": "Taluyaq",
        "images": [],
        "children": 3,
        "videoNumbers": [
            "cpb-aacip-127-00ns1t6z.h264",
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-23612qck.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-67wm3hhj.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "17.1.6.1": {
        "name": "Can'giircuun -- Blackfish Trap",
        "url": "Cangiircuun",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-23612qck.h264",
            "cpb-aacip-127-67wm3hhj.h264"
        ]
    },
    "17.1.6.3": {
        "name": "Cuignilngurcuun -- Land Otter Trap",
        "url": "Cuignilngurcuun",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-54kkwrd6.h264"
        ]
    },
    "17.1.7": {
        "name": "Qanikciurun -- Shovel",
        "url": "Qanikciurun",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-623bkbxr.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "17.3": {
        "name": "Saskut, Caskut -- Weapons",
        "url": "Saskut-Caskut",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-20fttjr7.h264"
        ]
    },
    "17.3.1": {
        "name": "Narulkaq -- Spear",
        "url": "Narulkaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-20fttjr7.h264"
        ]
    },
    "17.4": {
        "name": "Ayagassuutet -- Transportation",
        "url": "Ayagassuutet",
        "images": [],
        "children": 5,
        "videoNumbers": [
            "cpb-aacip-127-06g1jzz6.h264",
            "cpb-aacip-127-257d81kk.h264",
            "cpb-aacip-127-33rv1b2m.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-6341p189.h264",
            "cpb-aacip-127-65v6x4wh.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-719kdf8m.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "17.4.1": {
        "name": "Qimugta -- Dog",
        "url": "Qimugta",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-06g1jzz6.h264"
        ]
    },
    "17.4.1.1": {
        "name": "Qimugciryaraq -- Dog Mushing",
        "url": "Qimugciryaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-06g1jzz6.h264"
        ]
    },
    "17.4.2": {
        "name": "Snuukuuq -- Snowmachine, Snowgo, Snowmobile",
        "url": "Snuukuuq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-33rv1b2m.h264"
        ]
    },
    "17.4.3": {
        "name": "Qayaq -- Kayak",
        "url": "Qayaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-257d81kk.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-6341p189.h264",
            "cpb-aacip-127-65v6x4wh.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "17.4.4": {
        "name": "Egelrun -- Canoe",
        "url": "Egelrun",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-66vx0v02.h264"
        ]
    },
    "17.4.5": {
        "name": "Angyaq -- Boat",
        "url": "Angyaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-719kdf8m.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "17.5": {
        "name": "Tupigyaraq -- Grass Weaving",
        "url": "Tupigyaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-76f1vspw.h264"
        ]
    },
    "17.6": {
        "name": "Murak -- Wood",
        "url": "Murak",
        "images": [],
        "children": 2,
        "videoNumbers": [
            "cpb-aacip-127-00ns1t6z.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-67wm3hhj.h264"
        ]
    },
    "17.6.2": {
        "name": "Equgtaryaraq -- Gathering Wood",
        "url": "Equgtaryaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-66vx0v02.h264"
        ]
    },
    "17.7": {
        "name": "Mingqaat -- Grass Baskets",
        "url": "Mingqaat",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-66vx0v02.h264"
        ]
    },
    "17.8": {
        "name": "Teq'icilleq, Teq'iciraq -- Aged Urine",
        "url": "Teqicilleq-Teqiciraq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-54kkwrd6.h264"
        ]
    },
    "18": {
        "name": "Naanguat Aquiyarat-llu -- Toys & Games",
        "url": "Naanguat-Aquiyarat-llu",
        "images": [
            "NaanguatAquiyaratllu.jpg"
        ],
        "children": 4,
        "videoNumbers": [
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-59c5b6f6.h264",
            "cpb-aacip-127-66vx0v02.h264"
        ]
    },
    "18.1": {
        "name": "Irniaruat, Inuguat -- Dolls",
        "url": "Irniaruat-Inuguat",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-59c5b6f6.h264",
            "cpb-aacip-127-66vx0v02.h264"
        ]
    },
    "18.2": {
        "name": "Airraq -- String Games",
        "url": "Airraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-66vx0v02.h264"
        ]
    },
    "18.3": {
        "name": "Yaaruin -- Story Knife",
        "url": "Yaaruin",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-66vx0v02.h264"
        ]
    },
    "18.4": {
        "name": "Naumalriit Enenguat -- Households Made of Plants",
        "url": "Naumalriit-Enenguat",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-66vx0v02.h264"
        ]
    },
    "19": {
        "name": "Ukverput -- Traditional Beliefs",
        "url": "Ukverput",
        "images": [
            "Ukverput.jpg"
        ],
        "children": 17,
        "videoNumbers": [
            "cpb-aacip-127-009w0z0q.h264",
            "cpb-aacip-127-00ns1t6z.h264",
            "cpb-aacip-127-010p2r15.h264",
            "cpb-aacip-127-03cz8zdq.h264",
            "cpb-aacip-127-0644j324.h264",
            "cpb-aacip-127-0644j37r.h264",
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-10jsxpwg.h264",
            "cpb-aacip-127-10jsxpx6.h264",
            "cpb-aacip-127-149p8hcz.h264",
            "cpb-aacip-127-15p8d31m.h264",
            "cpb-aacip-127-16pzgr3f.h264",
            "cpb-aacip-127-18rbp380.h264",
            "cpb-aacip-127-20fttjr7.h264",
            "cpb-aacip-127-225b014v.h264",
            "cpb-aacip-127-23612qck.h264",
            "cpb-aacip-127-25k98x78.h264",
            "cpb-aacip-127-25x69tk3.h264",
            "cpb-aacip-127-26xwdh7k.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-2908kvc9.h264",
            "cpb-aacip-127-322bvwfr.h264",
            "cpb-aacip-127-34fn33pp.h264",
            "cpb-aacip-127-35gb5sdj.h264",
            "cpb-aacip-127-37vmd1rq.h264",
            "cpb-aacip-127-386hdxkk.h264",
            "cpb-aacip-127-38w9gpk2.h264",
            "cpb-aacip-127-41mgqv1k.h264",
            "cpb-aacip-127-42n5thvk.h264",
            "cpb-aacip-127-440rz436.h264",
            "cpb-aacip-127-47rn8x0g.h264",
            "cpb-aacip-127-48ffbpfx.h264",
            "cpb-aacip-127-53wstz0s.h264",
            "cpb-aacip-127-54kkwqvx.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-59c5b6f6.h264",
            "cpb-aacip-127-59c5b6gx.h264",
            "cpb-aacip-127-60qrfsqn.h264",
            "cpb-aacip-127-6341p189.h264",
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-65v6x4wh.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-67wm3hhj.h264",
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-719kdf8m.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-74cnpfqb.h264",
            "cpb-aacip-127-74cnpfr2.h264",
            "cpb-aacip-127-74qjqbsc.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-7634tx89.h264",
            "cpb-aacip-127-76f1vspw.h264",
            "cpb-aacip-127-773txm5v.h264",
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-79h44thw.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-81jhb5w6.h264",
            "cpb-aacip-127-84mkm6tr.h264",
            "cpb-aacip-127-85n8pw5n.h264",
            "cpb-aacip-127-86nzsk0r.h264",
            "cpb-aacip-127-87brvbt5.h264",
            "cpb-aacip-127-87pnw7r9.h264",
            "cpb-aacip-127-881jx4d6.h264",
            "cpb-aacip-127-89280sv6.h264",
            "cpb-aacip-127-89r22kjv.h264",
            "cpb-aacip-127-945qg6jq.h264",
            "cpb-aacip-127-956djvkd.h264",
            "cpb-aacip-127-988gtvzp.h264",
            "cpb-aacip-127-98mcvs0p.h264"
        ]
    },
    "19.2": {
        "name": "Cingumalleq -- Encouragement",
        "url": "Cingumalleq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-20fttjr7.h264"
        ]
    },
    "19.3": {
        "name": "Aarcirtuutet -- Warnings, Rules",
        "url": "Aarcirtuutet",
        "images": [],
        "children": 9,
        "videoNumbers": [
            "cpb-aacip-127-149p8hcz.h264",
            "cpb-aacip-127-34fn33pp.h264",
            "cpb-aacip-127-38w9gpk2.h264",
            "cpb-aacip-127-59c5b6f6.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-65v6x4wh.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-74cnpfr2.h264",
            "cpb-aacip-127-74qjqbsc.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-76f1vspw.h264",
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-87brvbt5.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "19.3.1": {
        "name": "Qavam Qessam-llu Pikaitnarquciak -- Sleep and Laziness Lead to Destitution",
        "url": "Qavam-Qessam-llu-Pikaitnarquciak",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-74cnpfr2.h264"
        ]
    },
    "19.3.2": {
        "name": "Akusrarun -- Mischief, Misconduct",
        "url": "Akusrarun",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-149p8hcz.h264",
            "cpb-aacip-127-38w9gpk2.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-87brvbt5.h264"
        ]
    },
    "19.3.2.1": {
        "name": "Nunalgutkenrilkemeggnun Nallunailuciit -- Being Widely Known",
        "url": "Nunalgutkenrilkemeggnun-Nallunailuciit",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-149p8hcz.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-87brvbt5.h264"
        ]
    },
    "19.3.3": {
        "name": "Aipangvailegmeng Akusrarcaraq -- Premarital Sex",
        "url": "Aipangvailegmeng-Akusrarcaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-59c5b6f6.h264",
            "cpb-aacip-127-65v6x4wh.h264",
            "cpb-aacip-127-87brvbt5.h264"
        ]
    },
    "19.3.4": {
        "name": "Qanrucunailnguut -- Those Who Don't Heed Advice",
        "url": "Qanrucunailnguut",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-34fn33pp.h264",
            "cpb-aacip-127-74qjqbsc.h264",
            "cpb-aacip-127-76f1vspw.h264"
        ]
    },
    "19.3.4.1": {
        "name": "Unguvamayuitut -- They Don't Live Long",
        "url": "Unguvamayuitut",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-34fn33pp.h264",
            "cpb-aacip-127-76f1vspw.h264"
        ]
    },
    "19.3.5": {
        "name": "Cacetulriim Arenqiallugtellerkaa -- Misfortune from Overconfidence",
        "url": "Cacetulriim-Arenqiallugtellerkaa",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-752fr7q2.h264"
        ]
    },
    "19.3.6": {
        "name": "Cigyak -- Split Spruce Blocking Door During Instruction",
        "url": "Cigyak",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "19.3.7": {
        "name": "Caniqerrilin, Caniqerrilitaq -- Woven Grass Belt Blocking Door During Instruction",
        "url": "Caniqerrilin-Caniqerrilitaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "19.3.8": {
        "name": "Anelria Taquilluku -- Giving Fate for One Who Goes Out",
        "url": "Anelria-Taquilluku",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "19.3.9": {
        "name": "Nakriarucaraq -- Losing Hunting Prowess",
        "url": "Nakriarucaraq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "19.3.9.1": {
        "name": "Angutet Iqairarkait Allakarluki -- Separate Men's Laundry",
        "url": "Angutet-Iqairarkait-Allakarluki",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "19.4": {
        "name": "Piciryaraput -- Customs",
        "url": "Piciryaraput",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-10jsxpwg.h264"
        ]
    },
    "19.4.1": {
        "name": "Merr'icaraq -- Giving Water To Animals",
        "url": "Merricaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-10jsxpwg.h264"
        ]
    },
    "19.5": {
        "name": "Qanruyutet, Qaneryarat -- Traditional Wisdom, Wise Words",
        "url": "Qanruyutet-Qaneryarat",
        "images": [],
        "children": 8,
        "videoNumbers": [
            "cpb-aacip-127-009w0z0q.h264",
            "cpb-aacip-127-00ns1t6z.h264",
            "cpb-aacip-127-0644j324.h264",
            "cpb-aacip-127-0644j37r.h264",
            "cpb-aacip-127-10jsxpx6.h264",
            "cpb-aacip-127-15p8d31m.h264",
            "cpb-aacip-127-16pzgr3f.h264",
            "cpb-aacip-127-20fttjr7.h264",
            "cpb-aacip-127-35gb5sdj.h264",
            "cpb-aacip-127-37vmd1rq.h264",
            "cpb-aacip-127-386hdxkk.h264",
            "cpb-aacip-127-38w9gpk2.h264",
            "cpb-aacip-127-41mgqv1k.h264",
            "cpb-aacip-127-440rz436.h264",
            "cpb-aacip-127-48ffbpfx.h264",
            "cpb-aacip-127-53wstz0s.h264",
            "cpb-aacip-127-54kkwqvx.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-59c5b6f6.h264",
            "cpb-aacip-127-60qrfsqn.h264",
            "cpb-aacip-127-6341p189.h264",
            "cpb-aacip-127-65v6x4wh.h264",
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-76f1vspw.h264",
            "cpb-aacip-127-773txm5v.h264",
            "cpb-aacip-127-79h44thw.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-84mkm6tr.h264",
            "cpb-aacip-127-85n8pw5n.h264",
            "cpb-aacip-127-87brvbt5.h264",
            "cpb-aacip-127-87pnw7r9.h264",
            "cpb-aacip-127-881jx4d6.h264",
            "cpb-aacip-127-89r22kjv.h264",
            "cpb-aacip-127-956djvkd.h264"
        ]
    },
    "19.5.1": {
        "name": "Piciuyaraq -- Truthfulness",
        "url": "Piciuyaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-009w0z0q.h264"
        ]
    },
    "19.5.2": {
        "name": "Qigcikiyaraq -- Respect",
        "url": "Qigcikiyaraq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "19.5.2.1": {
        "name": "Qantamitun Pitarrluku -- As Much as One's Own Bowl",
        "url": "Qantamitun-Pitarrluku",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "19.5.3": {
        "name": "Umyuartuyaraq -- Being Sensible",
        "url": "Umyuartuyaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-752fr7q2.h264"
        ]
    },
    "19.5.4": {
        "name": "Maligtaqustiin Yuunertutucia -- Those Who Heed Advice Live Long",
        "url": "Maligtaqustiin-Yuunertutucia",
        "images": [],
        "children": 4,
        "videoNumbers": [
            "cpb-aacip-127-38w9gpk2.h264",
            "cpb-aacip-127-76f1vspw.h264",
            "cpb-aacip-127-79h44thw.h264",
            "cpb-aacip-127-84mkm6tr.h264",
            "cpb-aacip-127-85n8pw5n.h264"
        ]
    },
    "19.5.4.1": {
        "name": "Keggukarangelria -- One So Old They Grow a New Set of Teeth",
        "url": "Keggukarangelria",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-79h44thw.h264"
        ]
    },
    "19.5.4.2": {
        "name": "Ciunerkaqegciarkauciat -- How They Will Have a Good Future",
        "url": "Ciunerkaqegciarkauciat",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-84mkm6tr.h264"
        ]
    },
    "19.5.4.3": {
        "name": "Cakviussiyaagngaitut -- They Won't Struggle Too Much",
        "url": "Cakviussiyaagngaitut",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-85n8pw5n.h264"
        ]
    },
    "19.5.4.4": {
        "name": "Elluarrluni Yuuciquq -- One Will Live Well",
        "url": "Elluarrluni-Yuuciquq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-38w9gpk2.h264"
        ]
    },
    "19.5.5": {
        "name": "Qaskuit Ayuquciit-llu -- Appearance and Nature",
        "url": "Qaskuit-Ayuquciit-llu",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-773txm5v.h264"
        ]
    },
    "19.5.7": {
        "name": "Cuqyucirluteng Qanruciaqluteng -- Teaching Through Metaphors",
        "url": "Cuqyucirluteng-Qanruciaqluteng",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "19.5.8": {
        "name": "Qalarutesteteng Murilkelluki -- Observe Instructors Intently",
        "url": "Qalarutesteteng-Murilkelluki",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-35gb5sdj.h264"
        ]
    },
    "19.6": {
        "name": "Alerquutet, Ayuqucirtuutet -- Instructions",
        "url": "Alerquutet-Ayuqucirtuutet",
        "images": [],
        "children": 14,
        "videoNumbers": [
            "cpb-aacip-127-009w0z0q.h264",
            "cpb-aacip-127-010p2r15.h264",
            "cpb-aacip-127-0644j37r.h264",
            "cpb-aacip-127-10jsxpwg.h264",
            "cpb-aacip-127-149p8hcz.h264",
            "cpb-aacip-127-15p8d31m.h264",
            "cpb-aacip-127-18rbp380.h264",
            "cpb-aacip-127-25x69tk3.h264",
            "cpb-aacip-127-2908kvc9.h264",
            "cpb-aacip-127-34fn33pp.h264",
            "cpb-aacip-127-35gb5sdj.h264",
            "cpb-aacip-127-41mgqv1k.h264",
            "cpb-aacip-127-42n5thvk.h264",
            "cpb-aacip-127-47rn8x0g.h264",
            "cpb-aacip-127-48ffbpfx.h264",
            "cpb-aacip-127-53wstz0s.h264",
            "cpb-aacip-127-54kkwqvx.h264",
            "cpb-aacip-127-6341p189.h264",
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-65v6x4wh.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-719kdf8m.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-74cnpfr2.h264",
            "cpb-aacip-127-74qjqbsc.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-7634tx89.h264",
            "cpb-aacip-127-773txm5v.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-81jhb5w6.h264",
            "cpb-aacip-127-85n8pw5n.h264",
            "cpb-aacip-127-86nzsk0r.h264",
            "cpb-aacip-127-881jx4d6.h264",
            "cpb-aacip-127-89280sv6.h264",
            "cpb-aacip-127-98mcvs0p.h264"
        ]
    },
    "19.6.1": {
        "name": "Maligtaquyaraq, Niisngayaraq -- Obedience",
        "url": "Maligtaquyaraq-Niisngayaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-25x69tk3.h264",
            "cpb-aacip-127-34fn33pp.h264",
            "cpb-aacip-127-53wstz0s.h264",
            "cpb-aacip-127-54kkwqvx.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-85n8pw5n.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "19.6.2": {
        "name": "Neryaraq -- Eating Habits",
        "url": "Neryaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-010p2r15.h264",
            "cpb-aacip-127-42n5thvk.h264",
            "cpb-aacip-127-63fxpxg0.h264"
        ]
    },
    "19.6.3": {
        "name": "Neqem, Neqkam Uqlautenritlkerkaa -- Not to Make a Mess with Food, Food Sources",
        "url": "Neqem-Neqkam-Uqlautenritlkerkaa",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-18rbp380.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "19.6.4": {
        "name": "Qessaicaraq -- Not Being Lazy",
        "url": "Qessaicaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-0644j37r.h264",
            "cpb-aacip-127-41mgqv1k.h264",
            "cpb-aacip-127-48ffbpfx.h264",
            "cpb-aacip-127-69m37zr9.h264"
        ]
    },
    "19.6.5": {
        "name": "Enem Ilua Carrirturyaraa -- Keeping the House Clean",
        "url": "Enem-Ilua-Carrirturyaraa",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-2908kvc9.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-773txm5v.h264"
        ]
    },
    "19.6.5.1": {
        "name": "Uqlam Yugmun Nepucuilucia -- Dirt Doesn't Stick to People",
        "url": "Uqlam-Yugmun-Nepucuilucia",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-773txm5v.h264"
        ]
    },
    "19.6.6": {
        "name": "Nunat Mer'et-llu Elisngaluki -- Know the Land and Water",
        "url": "Nunat-Meret-llu-Elisngaluki",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-752fr7q2.h264"
        ]
    },
    "19.6.7": {
        "name": "Tangvagluteng Elicungcaryaraq -- Learning through Observation",
        "url": "Tangvagluteng-Elicungcaryaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-2908kvc9.h264",
            "cpb-aacip-127-35gb5sdj.h264",
            "cpb-aacip-127-7634tx89.h264",
            "cpb-aacip-127-81jhb5w6.h264"
        ]
    },
    "19.6.8": {
        "name": "Cauryaraq -- Keeping Busy, Doing Chores",
        "url": "Cauryaraq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-2908kvc9.h264",
            "cpb-aacip-127-773txm5v.h264"
        ]
    },
    "19.6.8.1": {
        "name": "Calrunani Unguvamaniartuq -- To Live a Long and Healthy Life",
        "url": "Calrunani-Unguvamaniartuq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-773txm5v.h264"
        ]
    },
    "19.6.9": {
        "name": "Anelriani Ellam Qukaa Tangerrluku -- Look at the Center of the Universe When Going Out",
        "url": "Anelriani-Ellam-Qukaa-Tangerrluku",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-773txm5v.h264"
        ]
    },
    "19.6.10": {
        "name": "Qanminek Mulngaksaraq -- Careful with Words",
        "url": "Qanminek-Mulngaksaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-149p8hcz.h264",
            "cpb-aacip-127-85n8pw5n.h264"
        ]
    },
    "19.6.11": {
        "name": "Eneteng Uitanqegcinarqevkarluki -- Keep Your Houses Peaceful",
        "url": "Eneteng-Uitanqegcinarqevkarluki",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-86nzsk0r.h264"
        ]
    },
    "19.6.12": {
        "name": "Piqrartanrilnguut Ikayurluki -- Help the Decrepit",
        "url": "Piqrartanrilnguut-Ikayurluki",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-47rn8x0g.h264",
            "cpb-aacip-127-881jx4d6.h264",
            "cpb-aacip-127-89280sv6.h264"
        ]
    },
    "19.6.13": {
        "name": "Ikayuqengyaraq -- Helping Others",
        "url": "Ikayuqengyaraq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-881jx4d6.h264",
            "cpb-aacip-127-89280sv6.h264",
            "cpb-aacip-127-98mcvs0p.h264"
        ]
    },
    "19.6.13.1": {
        "name": "Erneq Aipirluku -- Living Another Day",
        "url": "Erneq-Aipirluku",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "19.7": {
        "name": "Eyagyaraq -- Abstinence Practices, Taboos",
        "url": "Eyagyaraq",
        "images": [],
        "children": 2,
        "videoNumbers": [
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-149p8hcz.h264",
            "cpb-aacip-127-23612qck.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-59c5b6f6.h264",
            "cpb-aacip-127-65v6x4wh.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-74cnpfqb.h264",
            "cpb-aacip-127-773txm5v.h264"
        ]
    },
    "19.7.1": {
        "name": "Agleryaraq -- Menstruation",
        "url": "Agleryaraq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-149p8hcz.h264",
            "cpb-aacip-127-23612qck.h264",
            "cpb-aacip-127-59c5b6f6.h264",
            "cpb-aacip-127-65v6x4wh.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-74cnpfqb.h264"
        ]
    },
    "19.7.1.1": {
        "name": "Aglenraraq -- First Year of Menstruation",
        "url": "Aglenraraq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-65v6x4wh.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-74cnpfqb.h264"
        ]
    },
    "19.7.2": {
        "name": "Essuicaraq -- Spiritual Cleanliness",
        "url": "Essuicaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-773txm5v.h264"
        ]
    },
    "19.8": {
        "name": "Yuuyaraq -- Way Of Life",
        "url": "Yuuyaraq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-0644j37r.h264",
            "cpb-aacip-127-16pzgr3f.h264",
            "cpb-aacip-127-25k98x78.h264",
            "cpb-aacip-127-26xwdh7k.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-38w9gpk2.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-74cnpfqb.h264",
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-85n8pw5n.h264",
            "cpb-aacip-127-86nzsk0r.h264"
        ]
    },
    "19.8.1": {
        "name": "Ellangyaraq -- Becoming Aware [Childhood]",
        "url": "Ellangyaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-0644j37r.h264",
            "cpb-aacip-127-38w9gpk2.h264",
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-86nzsk0r.h264"
        ]
    },
    "19.9": {
        "name": "Kencikiyaraq -- Reverence",
        "url": "Kencikiyaraq",
        "images": [],
        "children": 2,
        "videoNumbers": [
            "cpb-aacip-127-009w0z0q.h264",
            "cpb-aacip-127-10jsxpwg.h264",
            "cpb-aacip-127-10jsxpx6.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-37vmd1rq.h264",
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-74cnpfqb.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "19.9.1": {
        "name": "Nuna Meq-llu Kenciklukek -- Revere Land and Water",
        "url": "Nuna-Meq-llu-Kenciklukek",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-37vmd1rq.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "19.10": {
        "name": "Kenkiyaraq -- Showing Love",
        "url": "Kenkiyaraq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-010p2r15.h264",
            "cpb-aacip-127-149p8hcz.h264",
            "cpb-aacip-127-23612qck.h264",
            "cpb-aacip-127-37vmd1rq.h264",
            "cpb-aacip-127-59c5b6gx.h264",
            "cpb-aacip-127-6341p189.h264",
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-719kdf8m.h264",
            "cpb-aacip-127-87brvbt5.h264",
            "cpb-aacip-127-881jx4d6.h264",
            "cpb-aacip-127-988gtvzp.h264"
        ]
    },
    "19.10.1": {
        "name": "Kenkucaraq -- Loving Each Other",
        "url": "Kenkucaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-59c5b6gx.h264",
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-719kdf8m.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "19.11": {
        "name": "Kevgiurturyaraq -- Serving Others",
        "url": "Kevgiurturyaraq",
        "images": [],
        "children": 2,
        "videoNumbers": [
            "cpb-aacip-127-009w0z0q.h264",
            "cpb-aacip-127-47rn8x0g.h264",
            "cpb-aacip-127-74qjqbsc.h264",
            "cpb-aacip-127-76f1vspw.h264",
            "cpb-aacip-127-773txm5v.h264"
        ]
    },
    "19.11.1": {
        "name": "Akingellerkani Umyuaqevkenaku -- Do Not Expect Payment",
        "url": "Akingellerkani-Umyuaqevkenaku",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-47rn8x0g.h264",
            "cpb-aacip-127-74qjqbsc.h264"
        ]
    },
    "19.11.2": {
        "name": "Menuurcuitut -- They Don't Become Impure",
        "url": "Menuurcuitut",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-773txm5v.h264"
        ]
    },
    "19.12": {
        "name": "Naklekiyaraq -- Compassion",
        "url": "Naklekiyaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-009w0z0q.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-87brvbt5.h264"
        ]
    },
    "19.13": {
        "name": "Inerquutet -- Admonishments",
        "url": "Inerquutet",
        "images": [],
        "children": 18,
        "videoNumbers": [
            "cpb-aacip-127-009w0z0q.h264",
            "cpb-aacip-127-00ns1t6z.h264",
            "cpb-aacip-127-03cz8zdq.h264",
            "cpb-aacip-127-23612qck.h264",
            "cpb-aacip-127-25x69tk3.h264",
            "cpb-aacip-127-322bvwfr.h264",
            "cpb-aacip-127-386hdxkk.h264",
            "cpb-aacip-127-38w9gpk2.h264",
            "cpb-aacip-127-41mgqv1k.h264",
            "cpb-aacip-127-440rz436.h264",
            "cpb-aacip-127-53wstz0s.h264",
            "cpb-aacip-127-54kkwqvx.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-59c5b6gx.h264",
            "cpb-aacip-127-6341p189.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-67wm3hhj.h264",
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-719kdf8m.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-74cnpfqb.h264",
            "cpb-aacip-127-74qjqbsc.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-76f1vspw.h264",
            "cpb-aacip-127-773txm5v.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-84mkm6tr.h264",
            "cpb-aacip-127-86nzsk0r.h264",
            "cpb-aacip-127-881jx4d6.h264",
            "cpb-aacip-127-945qg6jq.h264",
            "cpb-aacip-127-988gtvzp.h264"
        ]
    },
    "19.13.1": {
        "name": "Teglegyaraq -- Stealing",
        "url": "Teglegyaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-009w0z0q.h264",
            "cpb-aacip-127-03cz8zdq.h264",
            "cpb-aacip-127-25x69tk3.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-719kdf8m.h264",
            "cpb-aacip-127-84mkm6tr.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "19.13.2": {
        "name": "Assiilkiurluteng Neresqevkenaki -- Do Not Dislike Food",
        "url": "Assiilkiurluteng-Neresqevkenaki",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-69m37zr9.h264"
        ]
    },
    "19.13.3": {
        "name": "Qessakiluteng Neresqevkenaki -- Do Not Reject Food",
        "url": "Qessakiluteng-Neresqevkenaki",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-69m37zr9.h264"
        ]
    },
    "19.13.4": {
        "name": "Akinauresqevkenaki -- Do Not Retaliate",
        "url": "Akinauresqevkenaki",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-54kkwqvx.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-69m37zr9.h264"
        ]
    },
    "19.13.5": {
        "name": "Qessayaraq -- Laziness",
        "url": "Qessayaraq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-86nzsk0r.h264"
        ]
    },
    "19.13.5.1": {
        "name": "Kaigasteńgurciiqut -- They Will Become Beggars",
        "url": "Kaigasteńgurciiqut",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-86nzsk0r.h264"
        ]
    },
    "19.13.6": {
        "name": "Ellminek Ataneqsaraq, Umyugiuryaraq -- Being Self-Interested",
        "url": "Ellminek-Ataneqsaraq-Umyugiuryaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-84mkm6tr.h264"
        ]
    },
    "19.13.7": {
        "name": "Nuyavvliisqevkenaki -- Keep Hair Kempt",
        "url": "Nuyavvliisqevkenaki",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-74cnpfqb.h264"
        ]
    },
    "19.13.8": {
        "name": "Erurirraarluteng Neq'liuryaraq -- Handle Food with Clean Hands",
        "url": "Erurirraarluteng-Neqliuryaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-74cnpfqb.h264"
        ]
    },
    "19.13.9": {
        "name": "Qumaqicaraq -- Sex Craze",
        "url": "Qumaqicaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-74cnpfqb.h264"
        ]
    },
    "19.13.10": {
        "name": "Nepaunani Yuuyaraq -- Living without Commotion",
        "url": "Nepaunani-Yuuyaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-74qjqbsc.h264"
        ]
    },
    "19.13.11": {
        "name": "Quyigingnaqsaraq -- Pride",
        "url": "Quyigingnaqsaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-76f1vspw.h264"
        ]
    },
    "19.13.12": {
        "name": "Kiuyaraq, Kiutaaryaraq -- Talking Back",
        "url": "Kiuyaraq-Kiutaaryaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-440rz436.h264",
            "cpb-aacip-127-76f1vspw.h264",
            "cpb-aacip-127-773txm5v.h264"
        ]
    },
    "19.13.13": {
        "name": "Tan'gaurluut Nasaurluut-llu Allakarluteng -- Boys and Girls Separate",
        "url": "Tangaurluut-Nasaurluut-llu-Allakarluteng",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-38w9gpk2.h264",
            "cpb-aacip-127-41mgqv1k.h264",
            "cpb-aacip-127-53wstz0s.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "19.13.14": {
        "name": "Eyurucaraq -- Defending Children",
        "url": "Eyurucaraq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-386hdxkk.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "19.13.14.1": {
        "name": "Iqlungarituut -- They Become Liars",
        "url": "Iqlungarituut",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "19.13.15": {
        "name": "Yuut Nalluatni Tegucaraq -- Taking Things Without Permission",
        "url": "Yuut-Nalluatni-Tegucaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-84mkm6tr.h264"
        ]
    },
    "19.13.16": {
        "name": "Iqluyaraq, Iqluquyaraq, Iqlungaryaraq -- Lying",
        "url": "Iqluyaraq-Iqluquyaraq-Iqlungaryaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-84mkm6tr.h264"
        ]
    },
    "19.13.17": {
        "name": "Aatailnguut -- Illegitimate Children",
        "url": "Aatailnguut",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-322bvwfr.h264",
            "cpb-aacip-127-53wstz0s.h264",
            "cpb-aacip-127-86nzsk0r.h264"
        ]
    },
    "19.13.18": {
        "name": "Yuilqumi Neplirasqevkenaki -- Do Not Be Noisy in the Wilderness",
        "url": "Yuilqumi-Neplirasqevkenaki",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-54kkwrd6.h264"
        ]
    },
    "19.14": {
        "name": "Takaqiyaraq -- Respect",
        "url": "Takaqiyaraq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-225b014v.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-85n8pw5n.h264",
            "cpb-aacip-127-87brvbt5.h264"
        ]
    },
    "19.14.1": {
        "name": "Angayuqateng Takaqluki -- Respect Your Parents",
        "url": "Angayuqateng-Takaqluki",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-225b014v.h264",
            "cpb-aacip-127-87brvbt5.h264"
        ]
    },
    "19.15": {
        "name": "Ciunerkiullret -- Future Predictions",
        "url": "Ciunerkiullret",
        "images": [],
        "children": 3,
        "videoNumbers": [
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-76f1vspw.h264",
            "cpb-aacip-127-988gtvzp.h264"
        ]
    },
    "19.15.1": {
        "name": "Ellam Iquklitlerkaa -- The End of the World",
        "url": "Ellam-Iquklitlerkaa",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-65h9w88k.h264"
        ]
    },
    "19.15.2": {
        "name": "Yuut Cimillerkaat -- People Will Change",
        "url": "Yuut-Cimillerkaat",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-988gtvzp.h264"
        ]
    },
    "19.16": {
        "name": "Eyat, Eyaryaraq -- Tattoos, Tattooing",
        "url": "Eyat-Eyaryaraq",
        "images": [],
        "children": 2,
        "videoNumbers": [
            "cpb-aacip-127-784j17vw.h264"
        ]
    },
    "19.16.2": {
        "name": "Anguyalriani Yugtellriit -- Kills During War",
        "url": "Anguyalriani-Yugtellriit",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-784j17vw.h264"
        ]
    },
    "20": {
        "name": "Kalukat -- Celebrations, Gatherings",
        "url": "Kalukat",
        "images": [
            "Kalukat.jpg"
        ],
        "children": 9,
        "videoNumbers": [
            "cpb-aacip-127-0644j324.h264",
            "cpb-aacip-127-06g1k008.h264",
            "cpb-aacip-127-09w0vx3c.h264",
            "cpb-aacip-127-14nk9d19.h264",
            "cpb-aacip-127-257d81m9.h264",
            "cpb-aacip-127-25k98x78.h264",
            "cpb-aacip-127-27zkh5wz.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-322bvwfr.h264",
            "cpb-aacip-127-35t76q2k.h264",
            "cpb-aacip-127-440rz436.h264",
            "cpb-aacip-127-47rn8x0g.h264",
            "cpb-aacip-127-57np5s39.h264",
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-87pnw7r9.h264",
            "cpb-aacip-127-89280sv6.h264"
        ]
    },
    "20.1": {
        "name": "Kevgiq, Kevgiryaraq -- Messenger Feast",
        "url": "Kevgiq-Kevgiryaraq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-322bvwfr.h264",
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "20.1.1": {
        "name": "Kassiyuq -- Kevgiq Dance Festival",
        "url": "Kassiyuq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-784j17vw.h264"
        ]
    },
    "20.2": {
        "name": "Yuraq -- Yup'ik Dance, Dancing",
        "url": "Yuraq",
        "images": [],
        "children": 5,
        "videoNumbers": [
            "cpb-aacip-127-14nk9d19.h264",
            "cpb-aacip-127-257d81m9.h264",
            "cpb-aacip-127-25k98x78.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-322bvwfr.h264",
            "cpb-aacip-127-57np5s39.h264",
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "20.2.1": {
        "name": "Yurarpalriit -- Dance Festivals",
        "url": "Yurarpalriit",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-322bvwfr.h264"
        ]
    },
    "20.2.2": {
        "name": "Yuarun -- Song",
        "url": "Yuarun",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-257d81m9.h264",
            "cpb-aacip-127-25k98x78.h264",
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "20.2.2.1": {
        "name": "Anqaraun -- Victory Song",
        "url": "Anqaraun",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-784j17vw.h264"
        ]
    },
    "20.2.3": {
        "name": "Kegginaquq -- Mask",
        "url": "Kegginaquq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-25k98x78.h264",
            "cpb-aacip-127-57np5s39.h264"
        ]
    },
    "20.2.4": {
        "name": "Cauyaq -- Drum",
        "url": "Cauyaq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "20.2.4.1": {
        "name": "Yuulak -- Pair of Ceremonial Drums",
        "url": "Yuulak",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "20.2.5": {
        "name": "Nerukaraat -- Ceremonial Bowls of Food",
        "url": "Nerukaraat",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "20.3": {
        "name": "Nakaciuryaraq -- Bladder Festival",
        "url": "Nakaciuryaraq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-06g1k008.h264",
            "cpb-aacip-127-89280sv6.h264"
        ]
    },
    "20.3.1": {
        "name": "Nakacuut -- Bladders",
        "url": "Nakacuut",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-06g1k008.h264",
            "cpb-aacip-127-89280sv6.h264"
        ]
    },
    "20.4": {
        "name": "Avgarutaaryaraq -- Invitation Contest",
        "url": "Avgarutaaryaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-09w0vx3c.h264"
        ]
    },
    "20.5": {
        "name": "Ingulagyagaq -- Ingulak Festival",
        "url": "Ingulagyagaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-27zkh5wz.h264",
            "cpb-aacip-127-322bvwfr.h264"
        ]
    },
    "20.6": {
        "name": "Uqiquryaraq -- Seal Party",
        "url": "Uqiquryaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-06g1k008.h264"
        ]
    },
    "20.7": {
        "name": "Pitqerraallret -- First Catches",
        "url": "Pitqerraallret",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "20.8": {
        "name": "Itruka'ar -- Inviting-In Feast",
        "url": "Itrukaar",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "20.9": {
        "name": "Kass'artaat -- Western Holidays",
        "url": "Kassartaat",
        "images": [],
        "children": 4,
        "videoNumbers": [
            "cpb-aacip-127-35t76q2k.h264",
            "cpb-aacip-127-440rz436.h264",
            "cpb-aacip-127-47rn8x0g.h264",
            "cpb-aacip-127-87pnw7r9.h264"
        ]
    },
    "20.9.1": {
        "name": "Slaaviq -- Russian Christmas",
        "url": "Slaaviq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-35t76q2k.h264",
            "cpb-aacip-127-87pnw7r9.h264"
        ]
    },
    "20.9.2": {
        "name": "Alussistuaq -- Christmas",
        "url": "Alussistuaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-47rn8x0g.h264"
        ]
    },
    "20.9.3": {
        "name": "Quyayaraq -- Thanksgiving",
        "url": "Quyayaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-440rz436.h264"
        ]
    },
    "21": {
        "name": "Ilaliuryaraq -- Social Structure",
        "url": "Ilaliuryaraq",
        "images": [
            "Ilaliuryaraq.jpg"
        ],
        "children": 7,
        "videoNumbers": [
            "cpb-aacip-127-03cz8zdq.h264",
            "cpb-aacip-127-10jsxpx6.h264",
            "cpb-aacip-127-14nk9d19.h264",
            "cpb-aacip-127-25k98x78.h264",
            "cpb-aacip-127-27zkh5wz.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-2908kvc9.h264",
            "cpb-aacip-127-37vmd1rq.h264",
            "cpb-aacip-127-38w9gpk2.h264",
            "cpb-aacip-127-46254fdx.h264",
            "cpb-aacip-127-48ffbpfx.h264",
            "cpb-aacip-127-53wstz0s.h264",
            "cpb-aacip-127-60qrfsqn.h264",
            "cpb-aacip-127-623bkbxr.h264",
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-719kdf8m.h264",
            "cpb-aacip-127-74cnpfr2.h264",
            "cpb-aacip-127-74qjqbsc.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-7634tx89.h264",
            "cpb-aacip-127-76f1vspw.h264",
            "cpb-aacip-127-773txm5v.h264",
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-89280sv6.h264",
            "cpb-aacip-127-89r22kjv.h264",
            "cpb-aacip-127-91sf7xm0.h264"
        ]
    },
    "21.1": {
        "name": "Ciuniuryaraq -- Welcoming Guests",
        "url": "Ciuniuryaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-89r22kjv.h264"
        ]
    },
    "21.2": {
        "name": "Qasgiq, Qaygiq -- Community or Men's House",
        "url": "Qasgiq-Qaygiq",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-03cz8zdq.h264",
            "cpb-aacip-127-10jsxpx6.h264",
            "cpb-aacip-127-14nk9d19.h264",
            "cpb-aacip-127-25k98x78.h264",
            "cpb-aacip-127-27zkh5wz.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-48ffbpfx.h264",
            "cpb-aacip-127-60qrfsqn.h264",
            "cpb-aacip-127-623bkbxr.h264",
            "cpb-aacip-127-719kdf8m.h264",
            "cpb-aacip-127-74cnpfr2.h264",
            "cpb-aacip-127-74qjqbsc.h264",
            "cpb-aacip-127-76f1vspw.h264",
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-91sf7xm0.h264"
        ]
    },
    "21.2.1": {
        "name": "Maqi -- Steambath, Fire Bath",
        "url": "Maqi",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-91sf7xm0.h264"
        ]
    },
    "21.3": {
        "name": "Nepiaq -- Sod-house",
        "url": "Nepiaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-38w9gpk2.h264"
        ]
    },
    "21.4": {
        "name": "Ilakucaraq, Ilakellriit, Ilakelriit -- Family",
        "url": "Ilakucaraq-Ilakellriit-Ilakelriit",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-46254fdx.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-7634tx89.h264",
            "cpb-aacip-127-89280sv6.h264"
        ]
    },
    "21.4.1": {
        "name": "Tungayiit, Tungelqut -- Relatives",
        "url": "Tungayiit-Tungelqut",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-89280sv6.h264"
        ]
    },
    "21.5": {
        "name": "Qanertet, Qanrucistet -- Traditional Instructors",
        "url": "Qanertet-Qanrucistet",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-74qjqbsc.h264"
        ]
    },
    "21.6": {
        "name": "Ilaliuryaraq -- Socializing",
        "url": "Ilaliuryaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-53wstz0s.h264",
            "cpb-aacip-127-773txm5v.h264"
        ]
    },
    "21.7": {
        "name": "Nunat Ancitullratnek -- How Villages Exiled Members",
        "url": "Nunat-Ancitullratnek",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-2908kvc9.h264"
        ]
    },
    "22": {
        "name": "Calricaraq -- Health & Wellness",
        "url": "Calricaraq",
        "images": [
            "Calricaraq.jpg"
        ],
        "children": 12,
        "videoNumbers": [
            "cpb-aacip-127-009w0z0q.h264",
            "cpb-aacip-127-010p2r15.h264",
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-10jsxpwg.h264",
            "cpb-aacip-127-10jsxpx6.h264",
            "cpb-aacip-127-225b014v.h264",
            "cpb-aacip-127-23612qck.h264",
            "cpb-aacip-127-25x69tk3.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-33rv1b2m.h264",
            "cpb-aacip-127-34fn33pp.h264",
            "cpb-aacip-127-386hdz1p.h264",
            "cpb-aacip-127-38w9gpk2.h264",
            "cpb-aacip-127-41mgqv1k.h264",
            "cpb-aacip-127-42n5thvk.h264",
            "cpb-aacip-127-440rz436.h264",
            "cpb-aacip-127-48ffbpfx.h264",
            "cpb-aacip-127-53wstz0s.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-59c5b6gx.h264",
            "cpb-aacip-127-60qrfsqn.h264",
            "cpb-aacip-127-6341p189.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-67wm3hhj.h264",
            "cpb-aacip-127-68kd59ft.h264",
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-719kdf8m.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-74cnpfqb.h264",
            "cpb-aacip-127-74cnpfr2.h264",
            "cpb-aacip-127-74qjqbsc.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-773txm5v.h264",
            "cpb-aacip-127-805x6mnx.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-84mkm6tr.h264",
            "cpb-aacip-127-86nzsk0r.h264",
            "cpb-aacip-127-87brvbt5.h264",
            "cpb-aacip-127-881jx4d6.h264",
            "cpb-aacip-127-89280sv6.h264",
            "cpb-aacip-127-956djvkd.h264",
            "cpb-aacip-127-96wwq9xv.h264",
            "cpb-aacip-127-98mcvs0p.h264"
        ]
    },
    "22.1": {
        "name": "Qingaryaraq -- Pregnancy",
        "url": "Qingaryaraq",
        "images": [],
        "children": 2,
        "videoNumbers": [
            "cpb-aacip-127-010p2r15.h264",
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-54kkwrd6.h264"
        ]
    },
    "22.1.1": {
        "name": "Irnicualleq -- Miscarriage",
        "url": "Irnicualleq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-10jsxpvr.h264"
        ]
    },
    "22.1.2": {
        "name": "Irniyaraq -- Giving Birth",
        "url": "Irniyaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-010p2r15.h264"
        ]
    },
    "22.2": {
        "name": "Anglicarillerkaq, Tukercaryaraq -- Child Rearing",
        "url": "Anglicarillerkaq-Tukercaryaraq",
        "images": [],
        "children": 3,
        "videoNumbers": [
            "cpb-aacip-127-009w0z0q.h264",
            "cpb-aacip-127-010p2r15.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-38w9gpk2.h264",
            "cpb-aacip-127-41mgqv1k.h264",
            "cpb-aacip-127-440rz436.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-86nzsk0r.h264",
            "cpb-aacip-127-89280sv6.h264"
        ]
    },
    "22.2.1": {
        "name": "Yagiravkenaki -- Do Not Raise a Hand Against Them",
        "url": "Yagiravkenaki",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-69m37zr9.h264"
        ]
    },
    "22.2.2": {
        "name": "Qanpautevkenaki -- Do Not Shout at Them",
        "url": "Qanpautevkenaki",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-440rz436.h264",
            "cpb-aacip-127-69m37zr9.h264"
        ]
    },
    "22.2.3": {
        "name": "Ceńirutevkenaki -- Do Not Take Them to Others' Houses",
        "url": "Ceńirutevkenaki",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-86nzsk0r.h264"
        ]
    },
    "22.3": {
        "name": "Auluksaraq -- Taking Care",
        "url": "Auluksaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-10jsxpwg.h264",
            "cpb-aacip-127-98mcvs0p.h264"
        ]
    },
    "22.4": {
        "name": "Ellminek Tuqutellerkaq -- Suicide",
        "url": "Ellminek-Tuqutellerkaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-53wstz0s.h264",
            "cpb-aacip-127-65h9w88k.h264"
        ]
    },
    "22.5": {
        "name": "Taangaq -- Alcohol",
        "url": "Taangaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-10jsxpx6.h264",
            "cpb-aacip-127-225b014v.h264",
            "cpb-aacip-127-23612qck.h264",
            "cpb-aacip-127-25x69tk3.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-34fn33pp.h264",
            "cpb-aacip-127-41mgqv1k.h264",
            "cpb-aacip-127-48ffbpfx.h264",
            "cpb-aacip-127-53wstz0s.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-59c5b6gx.h264",
            "cpb-aacip-127-60qrfsqn.h264",
            "cpb-aacip-127-6341p189.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-719kdf8m.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-74cnpfqb.h264",
            "cpb-aacip-127-74qjqbsc.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-84mkm6tr.h264",
            "cpb-aacip-127-86nzsk0r.h264",
            "cpb-aacip-127-87brvbt5.h264",
            "cpb-aacip-127-881jx4d6.h264",
            "cpb-aacip-127-956djvkd.h264"
        ]
    },
    "22.6": {
        "name": "Naulluun, Qenan, Nangtequn -- Sickness",
        "url": "Naulluun-Qenan-Nangtequn",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-74cnpfr2.h264",
            "cpb-aacip-127-773txm5v.h264"
        ]
    },
    "22.6.1": {
        "name": "Pelqevkenaki Ikayurluki -- Help Them Without Fear of Spread",
        "url": "Pelqevkenaki-Ikayurluki",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-773txm5v.h264"
        ]
    },
    "22.7": {
        "name": "Kuingirrluk -- Marijuana",
        "url": "Kuingirrluk",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-23612qck.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-84mkm6tr.h264",
            "cpb-aacip-127-86nzsk0r.h264",
            "cpb-aacip-127-87brvbt5.h264"
        ]
    },
    "22.8": {
        "name": "Umyuam Calritlerkaa -- Mental Health",
        "url": "Umyuam-Calritlerkaa",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-773txm5v.h264"
        ]
    },
    "22.8.1": {
        "name": "Qilnganeryaraq -- Grief",
        "url": "Qilnganeryaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-65h9w88k.h264"
        ]
    },
    "22.9": {
        "name": "Nernerrluut -- Food with Adverse Effects",
        "url": "Nernerrluut",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-66vx0v02.h264"
        ]
    },
    "22.9.1": {
        "name": "Ilussaqercaraq -- Food Poisoning",
        "url": "Ilussaqercaraq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-66vx0v02.h264"
        ]
    },
    "22.10": {
        "name": "Piunrissiyaayuitellrat Naulluussiyaayuunateng-llu -- Fewer Death and Sickness",
        "url": "Piunrissiyaayuitellrat-Naulluussiyaayuunateng-llu",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-66vx0v02.h264"
        ]
    },
    "22.11": {
        "name": "Yuungcarviit -- Clinics & Hospitals",
        "url": "Yuungcarviit",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-68kd59ft.h264"
        ]
    },
    "22.12": {
        "name": "Iinrut -- Medicine",
        "url": "Iinrut",
        "images": [],
        "children": 2,
        "videoNumbers": [
            "cpb-aacip-127-33rv1b2m.h264",
            "cpb-aacip-127-386hdz1p.h264",
            "cpb-aacip-127-42n5thvk.h264",
            "cpb-aacip-127-67wm3hhj.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-805x6mnx.h264",
            "cpb-aacip-127-87brvbt5.h264",
            "cpb-aacip-127-96wwq9xv.h264"
        ]
    },
    "22.12.1": {
        "name": "Kass'artaat -- Western Medicine",
        "url": "Kassartaat",
        "images": [],
        "children": 1,
        "videoNumbers": [
            "cpb-aacip-127-386hdz1p.h264",
            "cpb-aacip-127-805x6mnx.h264"
        ]
    },
    "22.12.1.1": {
        "name": "Tabasco -- Tabasco Sauce",
        "url": "Tabasco",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-805x6mnx.h264"
        ]
    },
    "22.12.2": {
        "name": "Yugtaat -- Yup'ik Remedies",
        "url": "Yugtaat",
        "images": [],
        "children": 5,
        "videoNumbers": [
            "cpb-aacip-127-33rv1b2m.h264",
            "cpb-aacip-127-386hdz1p.h264",
            "cpb-aacip-127-42n5thvk.h264",
            "cpb-aacip-127-67wm3hhj.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-805x6mnx.h264",
            "cpb-aacip-127-87brvbt5.h264",
            "cpb-aacip-127-96wwq9xv.h264"
        ]
    },
    "22.12.2.1": {
        "name": "Teq'uq -- Urine",
        "url": "Tequq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-33rv1b2m.h264",
            "cpb-aacip-127-42n5thvk.h264",
            "cpb-aacip-127-67wm3hhj.h264",
            "cpb-aacip-127-752fr7q2.h264"
        ]
    },
    "22.12.2.2": {
        "name": "Caqlaq -- Rosewort",
        "url": "Caqlaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-87brvbt5.h264",
            "cpb-aacip-127-96wwq9xv.h264"
        ]
    },
    "22.12.2.3": {
        "name": "Uquq -- Seal Oil",
        "url": "Uquq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-805x6mnx.h264",
            "cpb-aacip-127-87brvbt5.h264"
        ]
    },
    "22.12.2.4": {
        "name": "Atsaruaq -- False Chamomile",
        "url": "Atsaruaq",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-805x6mnx.h264"
        ]
    },
    "22.12.2.5": {
        "name": "Caiggluk, Qanganaruaq, Naunerrluk -- Wormwood",
        "url": "Caiggluk-Qanganaruaq-Naunerrluk",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-386hdz1p.h264"
        ]
    },
    "23": {
        "name": "Qalartellret Atrit -- Names of Speakers",
        "url": "Qalartellret-Atrit",
        "images": [
            "QalartellretAtrit.jpg"
        ],
        "children": 86,
        "videoNumbers": [
            "cpb-aacip-127-009w0z0q.h264",
            "cpb-aacip-127-00ns1t6z.h264",
            "cpb-aacip-127-010p2r15.h264",
            "cpb-aacip-127-032282mq.h264",
            "cpb-aacip-127-03cz8zdq.h264",
            "cpb-aacip-127-0644j324.h264",
            "cpb-aacip-127-0644j37r.h264",
            "cpb-aacip-127-06g1jzz6.h264",
            "cpb-aacip-127-06g1k008.h264",
            "cpb-aacip-127-085hqfqk.h264",
            "cpb-aacip-127-09w0vx3c.h264",
            "cpb-aacip-127-10jsxpvr.h264",
            "cpb-aacip-127-10jsxpwg.h264",
            "cpb-aacip-127-10jsxpx6.h264",
            "cpb-aacip-127-149p8hcz.h264",
            "cpb-aacip-127-14nk9d19.h264",
            "cpb-aacip-127-15p8d31m.h264",
            "cpb-aacip-127-16pzgr3f.h264",
            "cpb-aacip-127-18rbp380.h264",
            "cpb-aacip-127-20fttjr7.h264",
            "cpb-aacip-127-225b014v.h264",
            "cpb-aacip-127-23612qck.h264",
            "cpb-aacip-127-257d81kk.h264",
            "cpb-aacip-127-257d81m9.h264",
            "cpb-aacip-127-25k98x78.h264",
            "cpb-aacip-127-25x69tk3.h264",
            "cpb-aacip-127-26xwdh7k.h264",
            "cpb-aacip-127-27zkh5wz.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-2908kvc9.h264",
            "cpb-aacip-127-322bvwfr.h264",
            "cpb-aacip-127-33rv1b2m.h264",
            "cpb-aacip-127-34fn33pp.h264",
            "cpb-aacip-127-34sj40gx.h264",
            "cpb-aacip-127-35gb5sdj.h264",
            "cpb-aacip-127-35t76q2k.h264",
            "cpb-aacip-127-37hqc4tk.h264",
            "cpb-aacip-127-37vmd1rq.h264",
            "cpb-aacip-127-386hdxkk.h264",
            "cpb-aacip-127-386hdz1p.h264",
            "cpb-aacip-127-38w9gpk2.h264",
            "cpb-aacip-127-41mgqv1k.h264",
            "cpb-aacip-127-42n5thvk.h264",
            "cpb-aacip-127-440rz436.h264",
            "cpb-aacip-127-46254fdx.h264",
            "cpb-aacip-127-47rn8x0g.h264",
            "cpb-aacip-127-48ffbpfx.h264",
            "cpb-aacip-127-52j6qcr2.h264",
            "cpb-aacip-127-53wstz0s.h264",
            "cpb-aacip-127-54kkwqvx.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-558czhn9.h264",
            "cpb-aacip-127-57np5s39.h264",
            "cpb-aacip-127-59c5b6f6.h264",
            "cpb-aacip-127-59c5b6gx.h264",
            "cpb-aacip-127-59q2c3zn.h264",
            "cpb-aacip-127-60qrfsqn.h264",
            "cpb-aacip-127-623bkbxr.h264",
            "cpb-aacip-127-6341p189.h264",
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-65v6x4wh.h264",
            "cpb-aacip-127-66vx0v02.h264",
            "cpb-aacip-127-67wm3hhj.h264",
            "cpb-aacip-127-68kd59ft.h264",
            "cpb-aacip-127-69m37zr9.h264",
            "cpb-aacip-127-719kdf8m.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-74cnpfqb.h264",
            "cpb-aacip-127-74cnpfr2.h264",
            "cpb-aacip-127-74qjqbsc.h264",
            "cpb-aacip-127-752fr7q2.h264",
            "cpb-aacip-127-7634tx89.h264",
            "cpb-aacip-127-76f1vspw.h264",
            "cpb-aacip-127-773txm5v.h264",
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-79h44thw.h264",
            "cpb-aacip-127-805x6mnx.h264",
            "cpb-aacip-127-816m99hb.h264",
            "cpb-aacip-127-81jhb5w6.h264",
            "cpb-aacip-127-84mkm6tr.h264",
            "cpb-aacip-127-85n8pw5n.h264",
            "cpb-aacip-127-86nzsk0r.h264",
            "cpb-aacip-127-87brvbt5.h264",
            "cpb-aacip-127-87pnw7r9.h264",
            "cpb-aacip-127-881jx4d6.h264",
            "cpb-aacip-127-89280sv6.h264",
            "cpb-aacip-127-89r22kjv.h264",
            "cpb-aacip-127-91sf7xm0.h264",
            "cpb-aacip-127-945qg6jq.h264",
            "cpb-aacip-127-956djvkd.h264",
            "cpb-aacip-127-96wwq9xv.h264",
            "cpb-aacip-127-988gtvzp.h264",
            "cpb-aacip-127-98mcvs0p.h264"
        ]
    },
    "23.1": {
        "name": "Aacungaq ~ Willie Kasayulie -- Akiachak",
        "url": "Aacungaq-Willie-Kasayulie",
        "images": [
            "elder64.png",
            "elder77.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-48ffbpfx.h264",
            "cpb-aacip-127-59c5b6gx.h264"
        ]
    },
    "23.2": {
        "name": "Aalika'ar ~ Alexie Mochin -- Nanvarnarrlak (?), Atmautluak",
        "url": "Aalikaar-Alexie-Mochin",
        "images": [
            "elder102.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-81jhb5w6.h264"
        ]
    },
    "23.3": {
        "name": "Acacungaqa ~ Clotilda Stone -- Chevak",
        "url": "Acacungaqa-Clotilda-Stone",
        "images": [
            "elder108.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-87brvbt5.h264"
        ]
    },
    "23.4": {
        "name": "Ackiar ~ Nick Lupie -- Tuntutuliak",
        "url": "Ackiar-Nick-Lupie",
        "images": [
            "elder1.png",
            "elder69.png",
            "elder83.png",
            "elder94.png",
            "elder104.png",
            "elder169.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-00ns1t6z.h264",
            "cpb-aacip-127-085hqfqk.h264",
            "cpb-aacip-127-46254fdx.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-67wm3hhj.h264"
        ]
    },
    "23.5": {
        "name": "Akagalria \"Aanaq\" ~ Sophie Nick -- Atmautluak",
        "url": "Akagalria-\"Aanaq\"-Sophie-Nick",
        "images": [
            "elder97.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-74cnpfqb.h264"
        ]
    },
    "23.6": {
        "name": "Alciq ~ Maxie Altsik -- Qinaq, Nightmute",
        "url": "Alciq-Maxie-Altsik",
        "images": [
            "elder25.png",
            "elder167.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-15p8d31m.h264",
            "cpb-aacip-127-23612qck.h264"
        ]
    },
    "23.7": {
        "name": "Allranitailnguq Allran'aq ~ Joe Chief Sr. -- Urucaraq, Bethel",
        "url": "Allranitailnguq-Allranaq-Joe-Chief-Sr.",
        "images": [
            "elder19.png",
            "elder33.png",
            "elder41.png",
            "elder145.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-10jsxpx6.h264",
            "cpb-aacip-127-25x69tk3.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-719kdfjd.h264"
        ]
    },
    "23.8": {
        "name": "Anesia Hoover (?) -- Kasigluk",
        "url": "Anesia-Hoover-(?)",
        "images": [
            "elder87.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-65h9w88k.h264"
        ]
    },
    "23.9": {
        "name": "Angalraq ~ Andrew Paukan -- St. Mary's",
        "url": "Angalraq-Andrew-Paukan",
        "images": [
            "elder141.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-0644j324.h264"
        ]
    },
    "23.10": {
        "name": "Anganaran ~ Katherine Smart-Bell -- Hooper Bay",
        "url": "Anganaran-Katherine-Smart-Bell",
        "images": [
            "elder109.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-87brvbt5.h264"
        ]
    },
    "23.11": {
        "name": "Angukarnaq ~ Anissum Andrew Jacob -- Napaskiak",
        "url": "Angukarnaq-Anissum-Andrew-Jacob",
        "images": [
            "elder52.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-35t76q2k.h264"
        ]
    },
    "23.12": {
        "name": "Angut'aq ~ Olinka Nickolai -- Kwethluk",
        "url": "Angutaq-Olinka-Nickolai",
        "images": [
            "elder74.png",
            "elder112.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-59c5b6f6.h264",
            "cpb-aacip-127-89r22kjv.h264"
        ]
    },
    "23.13": {
        "name": "Angutevialuk ~ Albert Beaver -- Kwigillingok",
        "url": "Angutevialuk-Albert-Beaver",
        "images": [
            "elder53.png",
            "elder92.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-37hqc4tk.h264",
            "cpb-aacip-127-65v6x4wh.h264"
        ]
    },
    "23.14": {
        "name": "Anguyaluk Taac'aq ~ Olinka Pavilla -- Nunacuaq (?), Kasigluk (?), Atmautluak",
        "url": "Anguyaluk-Taacaq-Olinka-Pavilla",
        "images": [
            "elder127.png",
            "elder166.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-23612qck.h264",
            "cpb-aacip-127-386hdxkk.h264"
        ]
    },
    "23.15": {
        "name": "Apaqutaq ~ Dick Andrew -- Bethel, Kayalivik",
        "url": "Apaqutaq-Dick-Andrew",
        "images": [
            "elder30.png",
            "elder98.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-25k98x78.h264",
            "cpb-aacip-127-74cnpfr2.h264"
        ]
    },
    "23.16": {
        "name": "Arnaaquq Aqesgirpak ~ Mary Worm -- Kongiganak",
        "url": "Arnaaquq-Aqesgirpak-Mary-Worm",
        "images": [
            "elder31.png",
            "elder49.png",
            "elder65.png",
            "elder67.png",
            "elder88.png",
            "elder101.png",
            "elder124.png",
            "elder146.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-257d81m9.h264",
            "cpb-aacip-127-25x69tk3.h264",
            "cpb-aacip-127-34fn33pp.h264",
            "cpb-aacip-127-52j6qcr2.h264",
            "cpb-aacip-127-54kkwqvx.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-79h44thw.h264"
        ]
    },
    "23.17": {
        "name": "Ayagina'ar ~ Nicholas Charles Sr. -- Bethel",
        "url": "Ayaginaar-Nicholas-Charles-Sr.",
        "images": [
            "elder36.png",
            "elder48.png",
            "elder130.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-33rv1b2m.h264",
            "cpb-aacip-127-440rz436.h264"
        ]
    },
    "23.18": {
        "name": "Ayagkaq ~ Wassillie B. Evan -- Napakiak",
        "url": "Ayagkaq-Wassillie-B.-Evan",
        "images": [
            "elder26.png",
            "elder26.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-06g1k008.h264",
            "cpb-aacip-127-16pzgr3f.h264"
        ]
    },
    "23.19": {
        "name": "Ayaprun ~ James Peter Sr. -- Kipnuk, Bethel",
        "url": "Ayaprun-James-Peter-Sr.",
        "images": [
            "elder5.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-06g1jzz6.h264"
        ]
    },
    "23.20": {
        "name": "Benedict Ketcheak -- Tapraq, Stebbins",
        "url": "Benedict-Ketcheak",
        "images": [
            "elder142.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-0644j324.h264"
        ]
    },
    "23.21": {
        "name": "Betty Guy -- Akiak",
        "url": "Betty-Guy",
        "images": [
            "elder95.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-68kd59ft.h264"
        ]
    },
    "23.22": {
        "name": "Billy Lincoln Sr. -- Toksook Bay",
        "url": "Billy-Lincoln-Sr.",
        "images": [
            "elder44.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-28ncjzpp.h264"
        ]
    },
    "23.23": {
        "name": "Caingilnguq ~ Albert Therchik",
        "url": "Caingilnguq-Albert-Therchik",
        "images": [
            "elder45.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-28ncjzpp.h264"
        ]
    },
    "23.24": {
        "name": "Caller'kuaq ~ William Lomack -- Akiachak (?)",
        "url": "Callerkuaq-William-Lomack",
        "images": [
            "elder63.png",
            "elder76.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-48ffbpfx.h264",
            "cpb-aacip-127-59c5b6gx.h264"
        ]
    },
    "23.25": {
        "name": "Carl Flynn -- Tununak",
        "url": "Carl-Flynn",
        "images": [
            "elder51.png",
            "elder51.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-18rbp380.h264",
            "cpb-aacip-127-35gb5sdj.h264"
        ]
    },
    "23.26": {
        "name": "Cialuq ~ Paul G. Nicolai -- Kwethluk",
        "url": "Cialuq-Paul-G.-Nicolai",
        "images": [
            "elder15.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-10jsxpvr.h264"
        ]
    },
    "23.27": {
        "name": "Cikiraq ~ Jane Green -- Hooper Bay",
        "url": "Cikiraq-Jane-Green",
        "images": [
            "elder107.png",
            "elder118.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-87brvbt5.h264",
            "cpb-aacip-127-96wwq9xv.h264"
        ]
    },
    "23.28": {
        "name": "Cimiciaq ~ Natalisia Smith -- Hooper Bay",
        "url": "Cimiciaq-Natalisia-Smith",
        "images": [
            "elder116.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-96wwq9xv.h264"
        ]
    },
    "23.29": {
        "name": "Cingliaq ~ Paul Gregory -- Bethel",
        "url": "Cingliaq-Paul-Gregory",
        "images": [
            "elder3.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-06g1jzz6.h264"
        ]
    },
    "23.30": {
        "name": "Cungauyar ~ Wassllie Andrew -- Kwethluk",
        "url": "Cungauyar-Wassllie-Andrew",
        "images": [
            "elder78.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-59q2c3zn.h264"
        ]
    },
    "23.31": {
        "name": "Cuukvak ~ Mary Neck -- Bethel",
        "url": "Cuukvak-Mary-Neck",
        "images": [
            "elder35.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-27zkh5wz.h264"
        ]
    },
    "23.32": {
        "name": "Emma Phillip (?) -- Kwigillingok, Tuluksak",
        "url": "Emma-Phillip-(?)",
        "images": [
            "elder62.png",
            "elder79.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-48ffbpfx.h264",
            "cpb-aacip-127-59q2c3zn.h264"
        ]
    },
    "23.33": {
        "name": "Fred Pavilla -- Atmautluak",
        "url": "Fred-Pavilla",
        "images": [
            "elder126.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-386hdxkk.h264"
        ]
    },
    "23.34": {
        "name": "Freda Beaver -- Kwigillingok",
        "url": "Freda-Beaver",
        "images": [
            "elder106.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-86nzsk0r.h264"
        ]
    },
    "23.35": {
        "name": "Ilanaq ~ Theresa Moses -- Toksook Bay",
        "url": "Ilanaq-Theresa-Moses",
        "images": [
            "elder42.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-28ncjzpp.h264"
        ]
    },
    "23.36": {
        "name": "Imguuq ~ Martha H. Jackson -- Tuulkessaaq, Kuiggluk",
        "url": "Imguuq-Martha-H.-Jackson",
        "images": [
            "elder66.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-53wstz0s.h264"
        ]
    },
    "23.37": {
        "name": "Ingallak ~ George Keene -- Kasigluk",
        "url": "Ingallak-George-Keene",
        "images": [
            "elder24.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-15p8d31m.h264"
        ]
    },
    "23.38": {
        "name": "James Guy -- Kwethluk",
        "url": "James-Guy",
        "images": [
            "elder2.png",
            "elder80.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-03cz8zdq.h264",
            "cpb-aacip-127-60qrfsqn.h264"
        ]
    },
    "23.39": {
        "name": "Joseph Evans (?)",
        "url": "Joseph-Evans-(?)",
        "images": [
            "elder149.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-719kdfjd.h264"
        ]
    },
    "23.40": {
        "name": "Kamluq ~ Kirt Bell -- Hooper Bay",
        "url": "Kamluq-Kirt-Bell",
        "images": [
            "cali3.png",
            "cali6.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-06g1k008.h264",
            "cpb-aacip-127-10jsxpwg.h264"
        ]
    },
    "23.41": {
        "name": "Kangrilnguq ~ Paul John -- Toksook Bay",
        "url": "Kangrilnguq-Paul-John",
        "images": [
            "elder43.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-28ncjzpp.h264"
        ]
    },
    "23.42": {
        "name": "Kayirayuaq ~ Eddie Bell Sr. -- Hooper Bay",
        "url": "Kayirayuaq-Eddie-Bell-Sr.",
        "images": [
            "cali1.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-06g1k008.h264"
        ]
    },
    "23.43": {
        "name": "Kelucaq ~ Joe Andrew -- Bethel",
        "url": "Kelucaq-Joe-Andrew",
        "images": [
            "elder170.png",
            "elder170.png",
            "elder170.png",
            "elder170.png",
            "elder170.png",
            "elder170.png",
            "elder170.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-010p2r15.h264",
            "cpb-aacip-127-06g1k008.h264",
            "cpb-aacip-127-10jsxpwg.h264",
            "cpb-aacip-127-18rbp380.h264",
            "cpb-aacip-127-881jx4d6.h264",
            "cpb-aacip-127-89280sv6.h264",
            "cpb-aacip-127-98mcvs0p.h264"
        ]
    },
    "23.44": {
        "name": "Ketacik (?) Ket'aq ~ Fannie Nicori -- Kwethluk",
        "url": "Ketacik-(?)-Ketaq-Fannie-Nicori",
        "images": [
            "elder135.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-440rz436.h264"
        ]
    },
    "23.45": {
        "name": "Kukuyar ~ Henry Frank -- Kwethluk",
        "url": "Kukuyar-Henry-Frank",
        "images": [
            "elder81.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-60qrfsqn.h264"
        ]
    },
    "23.46": {
        "name": "Kumangulria ~ Matthew Bean -- Mountain Village (?), Bethel, Acacaryun",
        "url": "Kumangulria-Matthew-Bean",
        "images": [
            "elder13.png",
            "elder32.png",
            "elder47.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-09w0vx3c.h264",
            "cpb-aacip-127-25x69tk3.h264",
            "cpb-aacip-127-28ncjzpp.h264"
        ]
    },
    "23.47": {
        "name": "Kumkaq ~ Noel Polty -- Pilot Station",
        "url": "Kumkaq-Noel-Polty",
        "images": [
            "elder139.png",
            "elder139.png",
            "elder139.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-386hdz1p.h264",
            "cpb-aacip-127-440rz436.h264",
            "cpb-aacip-127-623bkbxr.h264"
        ]
    },
    "23.48": {
        "name": "Kumluilnguq ~ Matthew Frye -- Napakiak",
        "url": "Kumluilnguq-Matthew-Frye",
        "images": [
            "elder150.png",
            "elder158.png",
            "elder163.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-6341p189.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-881jx4d6.h264"
        ]
    },
    "23.49": {
        "name": "Liguaq ~ Annabelle Olik -- Kwethluk (?)",
        "url": "Liguaq-Annabelle-Olik",
        "images": [
            "elder159.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-945qg6jq.h264"
        ]
    },
    "23.50": {
        "name": "Lucy Frank -- Kwethluk",
        "url": "Lucy-Frank",
        "images": [
            "elder82.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-60qrfsqn.h264"
        ]
    },
    "23.51": {
        "name": "Maqarualek ~ Edward Wise -- Tuluksak",
        "url": "Maqarualek-Edward-Wise",
        "images": [
            "elder10.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-06g1k008.h264"
        ]
    },
    "23.52": {
        "name": "Maqista Ac'urunaq ~ Joshua Phillip -- Tuluksak, Qinaq",
        "url": "Maqista-Acurunaq-Joshua-Phillip",
        "images": [
            "elder14.png",
            "elder23.png",
            "elder99.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-009w0z0q.h264",
            "cpb-aacip-127-15p8d31m.h264",
            "cpb-aacip-127-74qjqbsc.h264"
        ]
    },
    "23.53": {
        "name": "Maqista Ac'urunaq ~ Joshua Phillip -- Tuntutuliak, Qinaq",
        "url": "Maqista-Acurunaq-Joshua-Phillip",
        "images": [
            "elder54.png",
            "elder59.png",
            "elder155.png",
            "elder157.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-37vmd1rq.h264",
            "cpb-aacip-127-48ffbpfx.h264",
            "cpb-aacip-127-784j17vw.h264",
            "cpb-aacip-127-816m99hb.h264"
        ]
    },
    "23.54": {
        "name": "Miisaq ~ Milton Lewis -- Kwigillingok",
        "url": "Miisaq-Milton-Lewis",
        "images": [
            "elder110.png",
            "elder132.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-440rz436.h264",
            "cpb-aacip-127-87pnw7r9.h264"
        ]
    },
    "23.55": {
        "name": "Mikngayaq Mik'aq ~ Eliza Chase -- Bethel",
        "url": "Mikngayaq-Mikaq-Eliza-Chase",
        "images": [
            "elder38.png",
            "elder38.png",
            "elder38.png",
            "elder38.png",
            "elder38.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-06g1k008.h264",
            "cpb-aacip-127-18rbp380.h264",
            "cpb-aacip-127-225b014v.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-558czhn9.h264"
        ]
    },
    "23.56": {
        "name": "Mumess'aq ~ Peter John -- Kwigillingok",
        "url": "Mumessaq-Peter-John",
        "images": [
            "elder153.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-752fr7q2.h264"
        ]
    },
    "23.57": {
        "name": "Nanugaq ~ Fred Evan -- Napakiak, Bethel",
        "url": "Nanugaq-Fred-Evan",
        "images": [
            "elder6.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-06g1jzz6.h264"
        ]
    },
    "23.58": {
        "name": "Narullgiar ~ Elena Nick -- Nunapitchuk",
        "url": "Narullgiar-Elena-Nick",
        "images": [
            "elder68.png",
            "elder68.png",
            "elder123.png",
            "elder152.png",
            "elder162.png",
            "elder164.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-257d81kk.h264",
            "cpb-aacip-127-2908kvc9.h264",
            "cpb-aacip-127-34sj40gx.h264",
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-7634tx89.h264"
        ]
    },
    "23.59": {
        "name": "Nauciralrea ~ Joseph Friday -- Chevak",
        "url": "Nauciralrea-Joseph-Friday",
        "images": [
            "elder28.png",
            "elder40.png",
            "elder73.png",
            "elder84.png",
            "elder100.png",
            "elder131.png",
            "elder143.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-0644j324.h264",
            "cpb-aacip-127-20fttjr7.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-440rz436.h264",
            "cpb-aacip-127-57np5s39.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-76f1vspw.h264"
        ]
    },
    "23.60": {
        "name": "Nauyaq ~ Anna Andrew -- Tuntutuliak",
        "url": "Nauyaq-Anna-Andrew",
        "images": [
            "elder39.png",
            "elder90.png",
            "elder91.png",
            "elder121.png",
            "elder147.png",
            "elder151.png",
            "elder154.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-149p8hcz.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-773txm5v.h264"
        ]
    },
    "23.61": {
        "name": "Nengqerralria Nengeq'aq ~ Elena Charles -- Bethel, Kasigluk, Nunacuaq (?)",
        "url": "Nengqerralria-Nengeqaq-Elena-Charles",
        "images": [
            "elder37.png",
            "elder93.png",
            "elder125.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-322bvwfr.h264",
            "cpb-aacip-127-66vx0v02.h264"
        ]
    },
    "23.62": {
        "name": "Neviar Qakvaralria ~ Lucy Nicholai -- Eek, Kwethluk",
        "url": "Neviar-Qakvaralria-Lucy-Nicholai",
        "images": [
            "elder16.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-10jsxpvr.h264"
        ]
    },
    "23.63": {
        "name": "Nevicuk \"Narr'aq\" ~ Helen Nelson -- Naparyarraq",
        "url": "Nevicuk-\"Narraq\"-Helen-Nelson",
        "images": [
            "elder55.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-38w9gpk2.h264"
        ]
    },
    "23.64": {
        "name": "Nirraralria ~ Ulric Nayamin -- Chevak",
        "url": "Nirraralria-Ulric-Nayamin",
        "images": [
            "elder29.png",
            "elder133.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-20fttjr7.h264",
            "cpb-aacip-127-440rz436.h264"
        ]
    },
    "23.65": {
        "name": "Nurataaq ~ Nelson Angapak -- Tuntutuliak, Anchorage",
        "url": "Nurataaq-Nelson-Angapak",
        "images": [
            "elder34.png",
            "elder105.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-26xwdh7k.h264",
            "cpb-aacip-127-85n8pw5n.h264"
        ]
    },
    "23.66": {
        "name": "Oscar Anvil (?) -- Bethel, Nunacuaq (?)",
        "url": "Oscar-Anvil-(?)",
        "images": [
            "elder160.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-956djvkd.h264"
        ]
    },
    "23.67": {
        "name": "Panigkaq ~ Freda Beaver -- Kwigillingok",
        "url": "Panigkaq-Freda-Beaver",
        "images": [
            "elder60.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-48ffbpfx.h264"
        ]
    },
    "23.68": {
        "name": "Paniguaq ~ Peter Jacob -- Bethel",
        "url": "Paniguaq-Peter-Jacob",
        "images": [
            "elder7.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-06g1jzz6.h264"
        ]
    },
    "23.69": {
        "name": "Paningayaq ~ Guy Mann -- Hooper Bay",
        "url": "Paningayaq-Guy-Mann",
        "images": [
            "elder72.png",
            "elder115.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-96wwq9xv.h264"
        ]
    },
    "23.70": {
        "name": "Peter Isaac -- Bethel",
        "url": "Peter-Isaac",
        "images": [
            "elder4.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-06g1jzz6.h264"
        ]
    },
    "23.71": {
        "name": "Phillip Moses",
        "url": "Phillip-Moses",
        "images": [
            "cali5.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-06g1k008.h264"
        ]
    },
    "23.72": {
        "name": "Putyuk Puyuk ~ Della Keats -- Noatak, Kotzebue",
        "url": "Putyuk-Puyuk-Della-Keats",
        "images": [
            "elder129.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-386hdz1p.h264"
        ]
    },
    "23.73": {
        "name": "Qavarliaq ~ Johnny K. Guy -- Kwethluk",
        "url": "Qavarliaq-Johnny-K.-Guy",
        "images": [
            "elder22.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-14nk9d19.h264"
        ]
    },
    "23.74": {
        "name": "Qen'gauq ~ Oscar F. Alexie -- Naparyarraq",
        "url": "Qengauq-Oscar-F.-Alexie",
        "images": [
            "cali10.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-26xwdh7k.h264"
        ]
    },
    "23.75": {
        "name": "Quriciq ~ Nickolai K. Nicolai -- Kwethluk",
        "url": "Quriciq-Nickolai-K.-Nicolai",
        "images": [
            "elder75.png",
            "elder111.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-59c5b6f6.h264",
            "cpb-aacip-127-89r22kjv.h264"
        ]
    },
    "23.76": {
        "name": "Tamarqalria Tam'aq ~ Elizabeth Andrew -- Tuntutuliak",
        "url": "Tamarqalria-Tamaq-Elizabeth-Andrew",
        "images": [
            "elder70.png",
            "elder96.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-54kkwrd6.h264",
            "cpb-aacip-127-69m37zr9.h264"
        ]
    },
    "23.77": {
        "name": "Taulan ~ Paul Agimuk -- Toksook Bay",
        "url": "Taulan-Paul-Agimuk",
        "images": [
            "elder71.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-54kkwrd6.h264"
        ]
    },
    "23.78": {
        "name": "Tavkaralria ~ Jonathan Johnson -- Hooper Bay",
        "url": "Tavkaralria-Jonathan-Johnson",
        "images": [
            "elder86.png",
            "elder117.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-96wwq9xv.h264"
        ]
    },
    "23.79": {
        "name": "Tupagalria (?) ~ Jacob Little (?) -- Oscarville",
        "url": "Tupagalria-(?)-Jacob-Little-(?)",
        "images": [
            "elder140.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-0644j37r.h264"
        ]
    },
    "23.80": {
        "name": "Tuunralek ~ Jimmy Chimegalrea -- Napakiak, Qinaq",
        "url": "Tuunralek-Jimmy-Chimegalrea",
        "images": [
            "elder58.png",
            "elder89.png",
            "elder114.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-47rn8x0g.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-91sf7xm0.h264"
        ]
    },
    "23.81": {
        "name": "Uliggaq ~ Martha Oscar Sara -- Bethel",
        "url": "Uliggaq-Martha-Oscar-Sara",
        "images": [
            "elder12.png",
            "elder46.png",
            "elder144.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-09w0vx3c.h264",
            "cpb-aacip-127-28ncjzpp.h264",
            "cpb-aacip-127-719kdf8m.h264"
        ]
    },
    "23.82": {
        "name": "Urutaq ~ Lucy Beaver -- Bethel",
        "url": "Urutaq-Lucy-Beaver",
        "images": [
            "elder11.png",
            "elder18.png",
            "elder20.png",
            "elder27.png",
            "elder57.png",
            "elder120.png",
            "elder156.png",
            "elder18.png",
            "elder171.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-010p2r15.h264",
            "cpb-aacip-127-06g1k008.h264",
            "cpb-aacip-127-10jsxpwg.h264",
            "cpb-aacip-127-18rbp380.h264",
            "cpb-aacip-127-42n5thvk.h264",
            "cpb-aacip-127-805x6mnx.h264",
            "cpb-aacip-127-881jx4d6.h264",
            "cpb-aacip-127-89280sv6.h264",
            "cpb-aacip-127-98mcvs0p.h264"
        ]
    },
    "23.83": {
        "name": "Wasky Walters -- Mountain Village",
        "url": "Wasky-Walters",
        "images": [
            "elder134.png",
            "elder161.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-440rz436.h264",
            "cpb-aacip-127-988gtvzp.h264"
        ]
    },
    "23.84": {
        "name": "Wassillie J. Andrew -- Kwethluk",
        "url": "Wassillie-J.-Andrew",
        "images": [
            "elder61.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-48ffbpfx.h264"
        ]
    },
    "23.85": {
        "name": "Winifred Beans -- St. Mary's (?), Mountain Village (?)",
        "url": "Winifred-Beans",
        "images": [
            "elder56.png",
            "elder85.png",
            "elder103.png",
            "elder148.png",
            "elder168.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-032282mq.h264",
            "cpb-aacip-127-41mgqv1k.h264",
            "cpb-aacip-127-65h9w88k.h264",
            "cpb-aacip-127-719kdfjd.h264",
            "cpb-aacip-127-84mkm6tr.h264"
        ]
    },
    "23.86": {
        "name": "Yuk 01 ~ Unidentified",
        "url": "Yuk-01-Unidentified",
        "images": [
            "elder165.png"
        ],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-23612qck.h264"
        ]
    },
    "24": {
        "name": "Allat -- Uncategorized",
        "url": "Allat",
        "images": [
            "Allat.jpg"
        ],
        "children": 3,
        "videoNumbers": [
            "cpb-aacip-127-06g1jzz6.h264",
            "cpb-aacip-127-16pzgr3f.h264",
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-752fr7q2.h264"
        ]
    },
    "24.1": {
        "name": "Yuartet -- Search And Rescue",
        "url": "Yuartet",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-06g1jzz6.h264"
        ]
    },
    "24.2": {
        "name": "Yup'ik Nation",
        "url": "Yupik-Nation",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-16pzgr3f.h264"
        ]
    },
    "24.3": {
        "name": "Neq'liurtet, Yaquleyagiurtet, Kayanguyagiurtet -- Fish and Game, Fish and Wildlife",
        "url": "Neqliurtet-Yaquleyagiurtet-Kayanguyagiurtet",
        "images": [],
        "children": 0,
        "videoNumbers": [
            "cpb-aacip-127-63fxpxg0.h264",
            "cpb-aacip-127-752fr7q2.h264"
        ]
    },
    "unsorted": {
        "tags": []
    }
};